import axios from "axios";
import Swal from "sweetalert2";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import "./Calendar.css";
import * as React from "react";
import DatePicker from "react-date-picker";
import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import Logo from "./้logo";
import Avatar from '@mui/material/Avatar';
import {
  CancelOutlined,
  EventAvailable,
  EventBusy,
  Send,
} from "@mui/icons-material/";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box } from "@mui/system";
import {
  Container,
  TextField,
  Grid,
  CssBaseline,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Modal,
} from "@mui/material";
import Article from "./article";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { createTheme, ThemeProvider } from '@mui/material/styles';


const theme = createTheme();

const stylee = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "white",
  border: "2px solid #e79129",
  boxShadow: 24,
  p: 1,
};

const styleelogin = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "white",
  border: "2px solid #e79129",
  boxShadow: 24,
  p: 1,
};


const Appoinment = () => {
  const URL = "https://api.thaipadi.org";

  //date

  const [startDate, setStartDate] = useState(new Date());

  const [time, setTime] = useState(new Date().toLocaleTimeString())

  const [dayname, setDayname] = useState("");

  useEffect(() => {
    if (startDate.getDay() === 0) {
      setDayname("วันอาทิตย์");
      return;
    } else if (startDate.getDay() === 1) {
      setDayname("วันจันทร์");
      return;
    } else if (startDate.getDay() === 2) {
      setDayname("วันอังคาร");
      return;
    } else if (startDate.getDay() === 3) {
      setDayname("วันพุธ");
      return;
    } else if (startDate.getDay() === 4) {
      setDayname("วันพฤหัส");
      return;
    } else if (startDate.getDay() === 5) {
      setDayname("วันศุกร์");
      return;
    } else if (startDate.getDay() === 6) {
      setDayname("วันเสาร์");
    }
  }, [startDate]);

  const [data, setData] = useState([]);

  useEffect(() => {
    axios.get(`${URL}/users`).then((res) => {
      res.data.shift();
      res.data.shift();
      setData(res.data);
    });
  }, [URL]);


  useEffect(()=>{
    const datetime = setInterval(()=>{
      setTime(new Date().toLocaleTimeString())
    },5000)
    return()=>clearInterval(datetime)
  },[])

  const [search, setSearch] = useState("");
  const testtt = (e) => {
    return setSearch(e.target.value);
  };


  //date


  //cancel

  const canceldata = (AN) => {
    var data = JSON.stringify({
      AN: AN,
    });

    var config = {
      method: "delete",
      url: `${URL}/clearwomen`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "เสร็จสิ้น",
          text: "ทำการยกเลิกเรียบร้อย",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck91();
          recheck92();
          recheck93();
          // recheck94();
          recheck101();
          recheck102();
          recheck103();
          // recheck104();
          recheck131();
          recheck132();
          recheck133();
          // recheck134();
          recheck141();
          recheck142();
          recheck143();
          // recheck144();
          recheck95();
          recheck105();
          recheck135();
          recheck145();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const canceldatas = (AN) => {
    var data = JSON.stringify({
      AN: AN,
    });

    var config = {
      method: "delete",
      url: `${URL}/clearwomens`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "เสร็จสิ้น",
          text: "ทำการยกเลิกเรียบร้อย",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck91();
          recheck92();
          recheck93();
          // recheck94();
          recheck101();
          recheck102();
          recheck103();
          // recheck104();
          recheck131();
          recheck132();
          recheck133();
          // recheck134();
          recheck141();
          recheck142();
          recheck143();
          // recheck144();
          recheck95();
          recheck105();
          recheck135();
          recheck145();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const canceldatass = (AN) => {
    var data = JSON.stringify({
      AN: AN,
    });

    var config = {
      method: "delete",
      url: `${URL}/clearwomenss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "เสร็จสิ้น",
          text: "ทำการยกเลิกเรียบร้อย",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck91();
          recheck92();
          recheck93();
          // recheck94();
          recheck101();
          recheck102();
          recheck103();
          // recheck104();
          recheck131();
          recheck132();
          recheck133();
          // recheck134();
          recheck141();
          recheck142();
          recheck143();
          // recheck144();
          recheck95();
          recheck105();
          recheck135();
          recheck145();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const canceldatasss = (AN) => {
    var data = JSON.stringify({
      AN: AN,
    });

    var config = {
      method: "delete",
      url: `${URL}/clearwomensss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "เสร็จสิ้น",
          text: "ทำการยกเลิกเรียบร้อย",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck91();
          recheck92();
          recheck93();
          // recheck94();
          recheck101();
          recheck102();
          recheck103();
          // recheck104();
          recheck131();
          recheck132();
          recheck133();
          // recheck134();
          recheck141();
          recheck142();
          recheck143();
          // recheck144();
          recheck95();
          recheck105();
          recheck135();
          recheck145();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // const canceldataman = (AN) => {
  //   var data = JSON.stringify({
  //     AN: AN,
  //   });

  //   var config = {
  //     method: "delete",
  //     url: `${URL}/clearman`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios(config)
  //     .then(function (response) {
  //       Swal.fire({
  //         icon: "success",
  //         title: "เสร็จสิ้น",
  //         text: "ทำการยกเลิกเรียบร้อย",
  //         showConfirmButton: false,
  //         timer: 1500,
  //       }).then((result) => {
  //         recheck91();
  //         recheck92();
  //         recheck93();
  //         // recheck94();
  //         recheck101();
  //         recheck102();
  //         recheck103();
  //         // recheck104();
  //         recheck131();
  //         recheck132();
  //         recheck133();
  //         // recheck134();
  //         recheck141();
  //         recheck142();
  //         recheck143();
  //         // recheck144();
  //         recheck95();
  //         recheck105();
  //         recheck135();
  //         recheck145();
  //         ldataall();
  //         ldatas();
  //         ldatass();
  //         ldatasss();
  //         ldataman();
  //         appdataone();
  //         appdatatwo();
  //         appdatatree();
  //         appdatafour();
  //         appdatafive();
  //         passappblock();
  //         passappconfirm();
  //       });
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // };

  const canceldata2 = (AN) => {
    var data = JSON.stringify({
      TN: 2,
    });

    var config = {
      method: "put",
      url: `${URL}/confirmappoinments/${AN}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "เสร็จสิ้น",
          text: "ยืนยันการผิดนัดเรียบร้อย",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck91();
          recheck92();
          recheck93();
          // recheck94();
          recheck101();
          recheck102();
          recheck103();
          // recheck104();
          recheck131();
          recheck132();
          recheck133();
          // recheck134();
          recheck141();
          recheck142();
          recheck143();
          // recheck144();
          recheck95();
          recheck105();
          recheck135();
          recheck145();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const canceldatas2 = (AN) => {
    var data = JSON.stringify({
      TN: 2,
    });

    var config = {
      method: "put",
      url: `${URL}/confirmappoinmentss/${AN}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "เสร็จสิ้น",
          text: "ยืนยันการผิดนัดเรียบร้อย",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck91();
          recheck92();
          recheck93();
          // recheck94();
          recheck101();
          recheck102();
          recheck103();
          // recheck104();
          recheck131();
          recheck132();
          recheck133();
          // recheck134();
          recheck141();
          recheck142();
          recheck143();
          // recheck144();
          recheck95();
          recheck105();
          recheck135();
          recheck145();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const canceldatass2 = (AN) => {
    var data = JSON.stringify({
      TN: 2,
    });

    var config = {
      method: "put",
      url: `${URL}/confirmappoinmentsss/${AN}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "เสร็จสิ้น",
          text: "ยืนยันการผิดนัดเรียบร้อย",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck91();
          recheck92();
          recheck93();
          // recheck94();
          recheck101();
          recheck102();
          recheck103();
          // recheck104();
          recheck131();
          recheck132();
          recheck133();
          // recheck134();
          recheck141();
          recheck142();
          recheck143();
          // recheck144();
          recheck95();
          recheck105();
          recheck135();
          recheck145();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const canceldatasss2 = (AN) => {
    var data = JSON.stringify({
      TN: 2,
    });

    var config = {
      method: "put",
      url: `${URL}/confirmappoinmentssss/${AN}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "เสร็จสิ้น",
          text: "ยืนยันการผิดนัดเรียบร้อย",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck91();
          recheck92();
          recheck93();
          // recheck94();
          recheck101();
          recheck102();
          recheck103();
          // recheck104();
          recheck131();
          recheck132();
          recheck133();
          // recheck134();
          recheck141();
          recheck142();
          recheck143();
          // recheck144();
          recheck95();
          recheck105();
          recheck135();
          recheck145();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // const canceldataman2 = (AN) => {
  //   var data = JSON.stringify({
  //     TN: 2,
  //   });

  //   var config = {
  //     method: "put",
  //     url: `${URL}/confirmmanappoinments/${AN}`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios(config)
  //     .then(function (response) {
  //       Swal.fire({
  //         icon: "success",
  //         title: "เสร็จสิ้น",
  //         text: "ยืนยันการผิดนัดเรียบร้อย",
  //         showConfirmButton: false,
  //         timer: 2000,
  //       }).then((result) => {
  //         recheck91();
  //         recheck92();
  //         recheck93();
  //         // recheck94();
  //         recheck101();
  //         recheck102();
  //         recheck103();
  //         // recheck104();
  //         recheck131();
  //         recheck132();
  //         recheck133();
  //         // recheck134();
  //         recheck141();
  //         recheck142();
  //         recheck143();
  //         // recheck144();
  //         recheck95();
  //         recheck105();
  //         recheck135();
  //         recheck145();
  //         ldataall();
  //         ldatas();
  //         ldatass();
  //         ldatasss();
  //         ldataman();
  //         appdataone();
  //         appdatatwo();
  //         appdatatree();
  //         appdatafour();
  //         appdatafive();
  //         passappblock();
  //         passappconfirm();
  //       });
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // };

  //cancel



  //09:00

  //one

    //ยกเลิกนัด

    const handleCancelpin91 = (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const jsondata = JSON.stringify({
        tel: data9one.tel,
        pin: data.get('pin'),
      });
      var config = {
        method: 'post',
        url: 'https://api.thaipadi.org/checkpin',
        headers: {
          'Content-Type': 'application/json'
        },
        data: jsondata
      };
  
      axios(config)
        .then(function (response) {
          if (response.data.status === 'OK') {
            handleOpencancel91()
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'รหัสผ่านของท่านไม่ถูกต้อง',
              showConfirmButton: false,
              timer: 1500
            })
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    };
  
    //ยกเลิกนัด
  
    //จำนวนนัด
  
    const [amountmandata, setAmountmandata] = useState(0);
    const [amountdata, setAmountdata] = useState(0);
    const [amountdatas, setAmountdatas] = useState(0);
    const [amountdatass, setAmountdatass] = useState(0);
    const [amountdatasss, setAmountdatasss] = useState(0);
  
    //จำนวนนัด
  
    //checkpin
  
  
    //checkpin
  
    const handleCheckpin91 = (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const jsondata = JSON.stringify({
        tel: data.get('tel'),
        pin: data.get('pin'),
      });
      var config = {
        method: 'post',
        url: 'https://api.thaipadi.org/checkpin',
        headers: {
          'Content-Type': 'application/json'
        },
        data: jsondata
      };
  
      axios(config)
        .then(function (response) {
          if (response.data.status === 'OK') {
            axios.get(`${URL}/manappoinment/${response.data.TN}`).then((res) => {
              setAmountmandata(res.data.length);
            });
            axios.get(`${URL}/appoinment/${response.data.TN}`).then((res) => {
              setAmountdata(res.data.length);
            });
            axios.get(`${URL}/appoinments/${response.data.TN}`).then((res) => {
              setAmountdatas(res.data.length);
            });
            axios.get(`${URL}/appoinmentss/${response.data.TN}`).then((res) => {
              setAmountdatass(res.data.length);
            });
            axios.get(`${URL}/appoinmentsss/${response.data.TN}`).then((res) => {
              setAmountdatasss(res.data.length)
              setSelecttn91(response.data.TN);
              setSelectname91(`${response.data.prefix}${response.data.fname} ${response.data.lname}`);
              Swal.fire({
                icon: 'success',
                title: 'เข้าสู่ระบบสำเร็จ',
                showConfirmButton: false,
                timer: 1500
              }).then((result) => {
                handleClose91()
                handleOpen911()
              })
            });
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'เบอร์โทรศัพท์หรือรหัสผ่านไม่ถูกต้อง',
              showConfirmButton: false,
              timer: 1500
            })
          }
        })
        .catch(function (error) {
          console.log(error);
        });
  
  
    };
  
    //checkpin

  const [data9one, setData9one] = useState([]);
  const [data9one2, setData9one2] = useState([]);
  const [editButton91, setEditButton91] = useState(false);
  const [icon91, setIcon91] = useState(<EventAvailable />);
  const [status91, setStatus91] = useState("ว่าง");
  const [cfer91, setCfer91] = useState(true);
  const [cancel91, setCancel91] = useState(true);

  useEffect(() => {
    ldataall();
    ldatas();
    ldatass();
    ldataman();
    appdataone();
    appdatatwo();
    appdatatree();
    appdatafour();
    appdatafive();
    passappblock();
    passappconfirm();
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data9one1 = [
      {
        AN: null,
        TN: null,
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "09:00",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinment/9/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      const resdata91 = res.data.map((item) => {
        return item.TN;
      });
      if (res.data.length === 0) {
        setData9one(data9one1[0]);
        setEditButton91(false);
        setIcon91(<EventAvailable />);
        setStatus91("ว่างงง");
        setCancel91(true);
        setCfer91(true);
        return;
      } else if (res.data.length >= 1) {
        setData9one(res.data[0]);
        setEditButton91(true);
        setIcon91(<EventBusy />);
        setStatus91("ไม่ว่าง");
        if (dateInPast(startDate, new Date())) {
          if (resdata91[0] === 1 || resdata91[0] === 2) {
            setCfer91(true);
            setCancel91(true);
            return;
          } else if (resdata91[0] > 2 && resdata91[0] < 10) {
            setCfer91(true);
            setCancel91(false);
            return;
          } else if (resdata91[0] > 10) {
            setCfer91(false);
            setCancel91(false);
            return;
          } else {
            setCfer91(false);
            setCancel91(false);
            return;
          }
        } else {
          setCfer91(true);
          setCancel91(false);
          return;
        }
      }
    });
  }, [startDate, data9one2, URL, time]);

  
  // Modalsearch
  const [selecttn91, setSelecttn91] = useState("");
  const [selectname91, setSelectname91] = useState("");

  const [provider91, setProvider91] = useState("หญิง");
  const handleChangeprovider91 = (event) => {
    setProvider91(event.target.value);
  };

  const [service91, setService91] = useState("");
  const handleChange91 = (event) => {
    setService91(event.target.value);
  };

  const selectpatient91 = (TN, prefix, fname, lname) => {
    setSelecttn91(TN);
    setSelectname91(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment91 = () => {
    var data = JSON.stringify({
      TN: selecttn91,
      date: data9one.date,
      time: data9one.time,
      service: service91,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck91();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen91(false);
          setOpen911(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const addholiday = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    if (selecttn91 === 7) {
      var data = JSON.stringify({
        date: startDate.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }),
        dateget: bbb,
      });
      var config = {
        method: "post",
        url: `${URL}/holidays`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data.status));
          if (response.data["status"] === "OK") {
            recheck91();
            recheck92();
            recheck93();
            // recheck94();
            recheck101();
            recheck102();
            recheck103();
            // recheck104();
            recheck131();
            recheck132();
            recheck133();
            // recheck134();
            recheck141();
            recheck142();
            recheck143();
            // recheck144();
            recheck95();
            recheck105();
            recheck135();
            recheck145();
            return;
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "เพิ่มข้อมูลวันหยุดผิดพลาด",
              showConfirmButton: false,
              timer: 1500,
            }).then((result) => {
              return;
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      return;
    } else {
      return;
    }
  };

  const recheck91 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinment/9/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData9one2(res.data[0]);
    });
  };

  const [open91, setOpen91] = useState(false);
  const handleOpen91 = () => setOpen91(true);
  const handleClose91 = () => setOpen91(false);

  const [open911, setOpen911] = useState(false);
  const handleOpen911 = () => setOpen911(true);
  const handleClose911 = () => setOpen911(false);

  const [cancel911, setCancel911] = useState(false);
  const handleOpencancel911 = () => setCancel911(true);
  const handleClosecancel911 = () => setCancel911(false);

  const handleOpen = () => {
    Swal.fire({
      icon: "info",
      title: "ยังไม่เปิดให้บริการ",
      showConfirmButton: false,
      timer: 1500,
    }).then((result) => {
      return;
    });
  };

  const handleOpenin91 = () => {
    if (amountmandata + amountdata + amountdatas + amountdatass + amountdatasss >= 3) {
      Swal.fire({
        title: "ท่านนัดหมายเกินกำหนด",
        html: "<div>ระบบให้นัดหมายล้วงหน้าได้ไม่เกิน 3 ครั้ง</div>หากต้องการนัดหมายกรุณายกเลิกนัดหมายอื่นของท่านก่อน",
        icon: "error",
        confirmButtonColor: "#d33",
        confirmButtonText: "ปิด",
      }).then((result) => {
        if (result.isConfirmed) {
          setOpen91(false)
          setOpen911(false)
        }
      });
      return;
    }
    else {
      const bbb =
        startDate.getDate() +
        "-" +
        (startDate.getMonth() + 1) +
        "-" +
        startDate.getFullYear();
      const aaa = `${URL}/appoinment/9/`;
      const oneURL = aaa + bbb;
      axios.get(oneURL).then((res) => {
        if (res.data.length >= 1) {
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
            confirmButtonColor: "#d33",
            confirmButtonText: "ปิด",
          }).then((result) => {
            if (result.isConfirmed) {
              setOpen91(false);
              recheck91()
            }
          });
          return;
        } else if (!service91 || !selecttn91) {
          Swal.fire({
            icon: "warning",
            title: "คำเตือน",
            text: "กรุณาระบุหัตถการให้ถูกต้อง",
            showConfirmButton: false,
            timer: 2500,
          });
          return;
        }
        Swal.fire({
          title: "ยืนยันการนัดหมาย",
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        }).then((result) => {
          if (result.isConfirmed) {
            addholiday();
            addmanaappoinment91();
          }
        });
      });
    }
  };

  //Modalsearch

  const handleOpencancel91 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldata(data9one.AN);
        handleClosecancel911()
      }
    });
  };

  //one

  //two

    //ยกเลิกนัด

    const handleCancelpin92 = (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const jsondata = JSON.stringify({
        tel: data9one.tel,
        pin: data.get('pin'),
      });
      var config = {
        method: 'post',
        url: 'https://api.thaipadi.org/checkpin',
        headers: {
          'Content-Type': 'application/json'
        },
        data: jsondata
      };
  
      axios(config)
        .then(function (response) {
          if (response.data.status === 'OK') {
            handleOpencancel92()
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'รหัสผ่านของท่านไม่ถูกต้อง',
              showConfirmButton: false,
              timer: 1500
            })
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    };
  
    //ยกเลิกนัด
  



    //checkpin
  
    const handleCheckpin92 = (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const jsondata = JSON.stringify({
        tel: data.get('tel'),
        pin: data.get('pin'),
      });
      var config = {
        method: 'post',
        url: 'https://api.thaipadi.org/checkpin',
        headers: {
          'Content-Type': 'application/json'
        },
        data: jsondata
      };
  
      axios(config)
        .then(function (response) {
          if (response.data.status === 'OK') {
            axios.get(`${URL}/manappoinment/${response.data.TN}`).then((res) => {
              setAmountmandata(res.data.length);
            });
            axios.get(`${URL}/appoinment/${response.data.TN}`).then((res) => {
              setAmountdata(res.data.length);
            });
            axios.get(`${URL}/appoinments/${response.data.TN}`).then((res) => {
              setAmountdatas(res.data.length);
            });
            axios.get(`${URL}/appoinmentss/${response.data.TN}`).then((res) => {
              setAmountdatass(res.data.length);
            });
            axios.get(`${URL}/appoinmentsss/${response.data.TN}`).then((res) => {
              setAmountdatasss(res.data.length)
              setSelecttn92(response.data.TN);
              setSelectname92(`${response.data.prefix}${response.data.fname} ${response.data.lname}`);
              Swal.fire({
                icon: 'success',
                title: 'เข้าสู่ระบบสำเร็จ',
                showConfirmButton: false,
                timer: 1500
              }).then((result) => {
                handleClose92()
                handleOpen912()
              })
            });
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'เบอร์โทรศัพท์หรือรหัสผ่านไม่ถูกต้อง',
              showConfirmButton: false,
              timer: 1500
            })
          }
        })
        .catch(function (error) {
          console.log(error);
        });
  
  
    };
  
    //checkpin 




  const [data9two, setData9two] = useState([]);
  const [data9two2, setData9two2] = useState([]);
  const [editButton92, setEditButton92] = useState(false);
  const [icon92, setIcon92] = useState(<EventAvailable />);
  const [status92, setStatus92] = useState("ว่าง");
  const [cfer92, setCfer92] = useState(true);
  const [cancel92, setCancel92] = useState(true);

  useEffect(() => {
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data9one2 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "09:00",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "09:00",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinments/9/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata92 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            setData9two(data9one2[0]);
            setEditButton92(false);
            setIcon92(<EventAvailable />);
            setStatus92("ว่างงง");
            setCancel92(true);
            setCfer92(true);
            return;
          } else if (res.data.length >= 1) {
            setData9two(res.data[0]);
            setEditButton92(true);
            setIcon92(<EventBusy />);
            setStatus92("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata92[0] === 1 || resdata92[0] === 2) {
                setCfer92(true);
                setCancel92(true);
                return;
              } else if (resdata92[0] > 2 && resdata92[0] < 10) {
                setCfer92(true);
                setCancel92(false);
                return;
              } else if (resdata92[0] > 10) {
                setCfer92(false);
                setCancel92(false);
                return;
              } else {
                setCfer92(false);
                setCancel92(false);
                return;
              }
            } else {
              setCfer92(true);
              setCancel92(false);
              return;
            }
          }
        });
      } else {
        setData9two(data9one2[2]);
        setEditButton92(true);
        setIcon92(<EventBusy />);
        setStatus92("ไม่ว่าง");
        setCfer92(true);
        setCancel92(true);
        return;
      }
    });
  }, [startDate, data9two2, URL, time]);

  //Modalsearch

  const [selecttn92, setSelecttn92] = useState("");
  const [selectname92, setSelectname92] = useState("");

  const [provider92, setProvider92] = useState("หญิง");
  const handleChangeprovider92 = (event) => {
    setProvider92(event.target.value);
  };

  const [service92, setService92] = useState("");
  const handleChange92 = (event) => {
    setService92(event.target.value);
  };

  const selectpatient92 = (TN, prefix, fname, lname) => {
    setSelecttn92(TN);
    setSelectname92(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment92 = () => {
    var data = JSON.stringify({
      TN: selecttn92,
      date: data9two.date,
      time: data9two.time,
      service: service92,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinmentss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 2500,
        }).then((result) => {
          recheck92();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen92(false);
          setOpen912(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck92 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinments/9/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData9two2(res.data[0]);
    });
  };

  const [open92, setOpen92] = useState(false);
  const handleOpen92 = () => setOpen92(true);
  const handleClose92 = () => setOpen92(false);

  const [open912, setOpen912] = useState(false);
  const handleOpen912 = () => setOpen912(true);
  const handleClose912 = () => setOpen912(false);

  const [cancel912, setCancel912] = useState(false);
  const handleOpencancel912 = () => setCancel912(true);
  const handleClosecancel912 = () => setCancel912(false);




  const handleOpenin92 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinments/9/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen92(false);
            recheck92()
          }
        });
        return;
      } else if (!service92 || !selecttn92) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment92();
        }
      });
    });
  };

  //Modalsearch

  const handleOpencancel92 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldatas(data9two.AN);
      }
    });
  };

  //two

  //tree

  const [data9tree, setData9tree] = useState([]);
  const [data9tree2, setData9tree2] = useState([]);
  const [editButton93, setEditButton93] = useState(false);
  const [icon93, setIcon93] = useState(<EventAvailable />);
  const [status93, setStatus93] = useState("ว่าง");
  const [cfer93, setCfer93] = useState(true);
  const [cancel93, setCancel93] = useState(true);

  useEffect(() => {
    const roletoken = localStorage.getItem("role");
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data9one3 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "09:00",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "09:00",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinmentss/9/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata93 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            if (
              (startDate.getDay() === 0 || startDate.getDay() === 6) &&
              roletoken === "admin"
            ) {
              setData9tree(data9one3[1]);
              setEditButton93(true);
              setIcon93(<EventBusy />);
              setStatus93("ไม่ว่าง");
              setCancel93(true);
              setCfer93(true);
              return;
            }
            setData9tree(data9one3[0]);
            setEditButton93(false);
            setIcon93(<EventAvailable />);
            setStatus93("ว่างงง");
            setCancel93(true);
            setCfer93(true);
            return;
          } else if (res.data.length >= 1) {
            setData9tree(res.data[0]);
            setEditButton93(true);
            setIcon93(<EventBusy />);
            setStatus93("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata93[0] === 1 || resdata93[0] === 2) {
                setCfer93(true);
                setCancel93(true);
                return;
              } else if (resdata93[0] > 2 && resdata93[0] < 10) {
                setCfer93(true);
                setCancel93(false);
                return;
              } else if (resdata93[0] > 10) {
                setCfer93(false);
                setCancel93(false);
                return;
              } else {
                setCfer93(false);
                setCancel93(false);
                return;
              }
            } else {
              setCfer93(true);
              setCancel93(false);
              return;
            }
          }
        });
      } else {
        setData9tree(data9one3[2]);
        setEditButton93(true);
        setIcon93(<EventBusy />);
        setStatus93("ไม่ว่าง");
        setCfer93(true);
        setCancel93(true);
        return;
      }
    });
  }, [startDate, data9tree2, URL, time]);

  //Modalsearch

  const [selecttn93, setSelecttn93] = useState("");
  const [selectname93, setSelectname93] = useState("");

  const [provider93, setProvider93] = useState("หญิง");
  const handleChangeprovider93 = (event) => {
    setProvider93(event.target.value);
  };

  const [service93, setService93] = useState("");
  const handleChange93 = (event) => {
    setService93(event.target.value);
  };

  const selectpatient93 = (TN, prefix, fname, lname) => {
    setSelecttn93(TN);
    setSelectname93(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment93 = () => {
    var data = JSON.stringify({
      TN: selecttn93,
      date: data9tree.date,
      time: data9tree.time,
      service: service93,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinmentsss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck93();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen93(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck93 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentss/9/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData9tree2(res.data[0]);
    });
  };

  const [open93, setOpen93] = useState(false);
  const handleOpen93 = () => setOpen93(true);
  const handleClose93 = () => setOpen93(false);

  const handleOpenin93 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentss/9/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen93(false);
            recheck93()
          }
        });
        return;
      } else if (!service93 || !selecttn93) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment93();
        }
      });
    });
  };

  //Modalsearch


  const handleOpencancel93 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldatass(data9tree.AN);
      }
    });
  };

  //tree

  //five

  const [data9five, setData9five] = useState([]);
  const [data9five2, setData9five2] = useState([]);
  const [editButton95, setEditButton95] = useState(false);
  const [icon95, setIcon95] = useState(<EventAvailable />);
  const [status95, setStatus95] = useState("ว่าง");
  const [cfer95, setCfer95] = useState(true);
  const [cancel95, setCancel95] = useState(true);

  useEffect(() => {
    const roletoken = localStorage.getItem("role");
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data9one5 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "09:00",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "09:00",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinmentsss/9/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata95 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            if (
              (startDate.getDay() === 0 || startDate.getDay() === 6) &&
              roletoken === "admin"
            ) {
              setData9five(data9one5[1]);
              setEditButton95(true);
              setIcon95(<EventBusy />);
              setStatus95("ไม่ว่าง");
              setCancel95(true);
              setCfer95(true);
              return;
            }
            setData9five(data9one5[0]);
            setEditButton95(false);
            setIcon95(<EventAvailable />);
            setStatus95("ว่างงง");
            setCancel95(true);
            setCfer95(true);
            return;
          } else if (res.data.length >= 1) {
            setData9five(res.data[0]);
            setEditButton95(true);
            setIcon95(<EventBusy />);
            setStatus95("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata95[0] === 1 || resdata95[0] === 2) {
                setCfer95(true);
                setCancel95(true);
                return;
              } else if (resdata95[0] > 2 && resdata95[0] < 10) {
                setCfer95(true);
                setCancel95(false);
                return;
              } else if (resdata95[0] > 10) {
                setCfer95(false);
                setCancel95(false);
                return;
              } else {
                setCfer95(false);
                setCancel95(false);
                return;
              }
            } else {
              setCfer95(true);
              setCancel95(false);
              return;
            }
          }
        });
      } else {
        setData9five(data9one5[2]);
        setEditButton95(true);
        setIcon95(<EventBusy />);
        setStatus95("ไม่ว่าง");
        setCfer95(true);
        setCancel95(true);
        return;
      }
    });
  }, [startDate, data9five2, URL, time]);

  //Modalsearch

  const [selecttn95, setSelecttn95] = useState("");
  const [selectname95, setSelectname95] = useState("");

  const [provider95, setProvider95] = useState("หญิง");
  const handleChangeprovider95 = (event) => {
    setProvider95(event.target.value);
  };

  const [service95, setService95] = useState("");
  const handleChange95 = (event) => {
    setService95(event.target.value);
  };

  const selectpatient95 = (TN, prefix, fname, lname) => {
    setSelecttn95(TN);
    setSelectname95(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment95 = () => {
    var data = JSON.stringify({
      TN: selecttn95,
      date: data9five.date,
      time: data9five.time,
      service: service95,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinmentssss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck95();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen95(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck95 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentsss/9/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData9five2(res.data[0]);
    });
  };

  const [open95, setOpen95] = useState(false);
  const handleOpen95 = () => setOpen95(true);
  const handleClose95 = () => setOpen95(false);

  const handleOpenin95 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentsss/9/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen95(false);
            recheck95()
          }
        });
        return;
      } else if (!service95 || !selecttn95) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment95();
        }
      });
    });
  };

  //Modalsearch


  const handleOpencancel95 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldatasss(data9five.AN);
      }
    });
  };

  //five


  //four

  // const [data9four, setData9four] = useState([]);
  // const [data9four2, setData9four2] = useState([]);
  // const [editButton94, setEditButton94] = useState(false);
  // const [icon94, setIcon94] = useState(<EventAvailable />);
  // const [status94, setStatus94] = useState("ว่าง");
  // const [cfer94, setCfer94] = useState(true);
  // const [cancel94, setCancel94] = useState(true);

  // useEffect(() => {
  //   const roletoken = localStorage.getItem("role");
  //   const dateInPast = function (firstDate, secondDate) {
  //     if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
  //       return true;
  //     }
  //     return false;
  //   };
  //   const bbb =
  //     startDate.getDate() +
  //     "-" +
  //     (startDate.getMonth() + 1) +
  //     "-" +
  //     startDate.getFullYear();
  //   const data9one4 = [
  //     {
  //       fname: "ว่าง",
  //       lname: null,
  //       service: "ว่าง",
  //       provider: "ชาย",
  //       date: bbb,
  //       time: "09:00",
  //       prefix: null,
  //     },
  //     {
  //       fname: null,
  //       lname: null,
  //       service: null,
  //       provider: null,
  //       date: null,
  //       time: null,
  //       prefix: null,
  //     },
  //     {
  //       AN: null,
  //       TN: null,
  //       fname: "ปิดบริการ",
  //       lname: "วันหยุดราชการ",
  //       service: "วันหยุดราชการหรืออื่นๆ",
  //       provider: "ชาย",
  //       date: bbb,
  //       time: "09:00",
  //       prefix: null,
  //     },
  //   ];
  //   const aaa = `${URL}/manappoinment/9/`;
  //   const oneURL = aaa + bbb;
  //   const holidaysURL = `${URL}/holidays`;
  //   axios.get(`${holidaysURL}`).then((res) => {
  //     const holidaysearch = startDate.toLocaleDateString("th-TH", {
  //       year: "numeric",
  //       month: "long",
  //       day: "numeric",
  //     });
  //     const holidays = res.data.map((item) => item.date);
  //     const arrayIncludes = holidays.includes(holidaysearch);
  //     if (arrayIncludes !== true) {
  //       axios.get(oneURL).then((res) => {
  //         const resdata94 = res.data.map((item) => {
  //           return item.TN;
  //         });
  //         if (res.data.length === 0) {
  //           if (
  //             (startDate.getDay() === 0 || startDate.getDay() === 6) &&
  //             roletoken === "admin"
  //           ) {
  //             setData9four(data9one4[1]);
  //             setEditButton94(true);
  //             setIcon94(<EventBusy />);
  //             setStatus94("ไม่ว่าง");
  //             setCfer94(true);
  //             setCancel94(true);
  //             return;
  //           }
  //           setData9four(data9one4[0]);
  //           setEditButton94(false);
  //           setIcon94(<EventAvailable />);
  //           setStatus94("ว่างงง");
  //           setCancel94(true);
  //           setCfer94(true);
  //           return;
  //         } else if (res.data.length >= 1) {
  //           setData9four(res.data[0]);
  //           setEditButton94(true);
  //           setIcon94(<EventBusy />);
  //           setStatus94("ไม่ว่าง");
  //           if (dateInPast(startDate, new Date())) {
  //             if (resdata94[0] === 1 || resdata94[0] === 2) {
  //               setCfer94(true);
  //               setCancel94(true);
  //               return;
  //             } else if (resdata94[0] > 2 && resdata94[0] < 10) {
  //               setCfer94(true);
  //               setCancel94(false);
  //               return;
  //             } else if (resdata94[0] > 10) {
  //               setCfer94(false);
  //               setCancel94(false);
  //               return;
  //             } else {
  //               setCfer94(false);
  //               setCancel94(false);
  //               return;
  //             }
  //           } else {
  //             setCfer94(true);
  //             setCancel94(false);
  //             return;
  //           }
  //         }
  //       });
  //     } else {
  //       setData9four(data9one4[2]);
  //       setEditButton94(true);
  //       setIcon94(<EventBusy />);
  //       setStatus94("ไม่ว่าง");
  //       setCfer94(true);
  //       setCancel94(true);
  //       return;
  //     }
  //   });
  // }, [startDate, data9four2, URL, time]);

  // //Modalsearch

  // const [selecttn94, setSelecttn94] = useState("");
  // const [selectname94, setSelectname94] = useState("");

  // const [provider94, setProvider94] = useState("ชาย");
  // const handleChangeprovider94 = (event) => {
  //   setProvider94(event.target.value);
  // };

  // const [service94, setService94] = useState("");
  // const handleChange94 = (event) => {
  //   setService94(event.target.value);
  // };

  // const selectpatient94 = (TN, prefix, fname, lname) => {
  //   setSelecttn94(TN);
  //   setSelectname94(`${prefix}${fname} ${lname}`);
  // };

  // const addmanaappoinment94 = () => {
  //   var data = JSON.stringify({
  //     TN: selecttn94,
  //     date: data9four.date,
  //     time: data9four.time,
  //     service: service94,
  //     provider: provider94,
  //   });

  //   var config = {
  //     method: "post",
  //     url: `${URL}/manapppoinment`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios(config)
  //     .then(function (response) {
  //       Swal.fire({
  //         icon: "success",
  //         title: "นัดหมายเรียบร้อย ",
  //         text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
  //         showConfirmButton: false,
  //         timer: 1500,
  //       }).then((result) => {
  //         recheck94();
  //         ldataall();
  //         ldatas();
  //         ldatass();
  //         ldatasss();
  //         ldataman();
  //         appdataone();
  //         appdatatwo();
  //         appdatatree();
  //         appdatafour();
  //         appdatafive();
  //         passappblock();
  //         passappconfirm();
  //         setOpen94(false);
  //       });
  //     })
  //     .catch(function (error) {
  //       alert(error);
  //     });
  // };

  // const recheck94 = () => {
  //   const bbb =
  //     startDate.getDate() +
  //     "-" +
  //     (startDate.getMonth() + 1) +
  //     "-" +
  //     startDate.getFullYear();
  //   const aaa = `${URL}/manappoinment/9/`;
  //   const oneURL = aaa + bbb;
  //   axios.get(oneURL).then((res) => {
  //     setData9four2(res.data[0]);
  //   });
  // };

  // const [open94, setOpen94] = useState(false);
  // const handleOpen94 = () => setOpen94(true);
  // const handleClose94 = () => setOpen94(false);

  // const handleOpenin94 = () => {
  //   const bbb =
  //     startDate.getDate() +
  //     "-" +
  //     (startDate.getMonth() + 1) +
  //     "-" +
  //     startDate.getFullYear();
  //   const aaa = `${URL}/manappoinment/9/`;
  //   const oneURL = aaa + bbb;
  //   axios.get(oneURL).then((res) => {
  //     if (res.data.length >= 1) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "เกิดข้อผิดพลาด",
  //         text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
  //         confirmButtonColor: "#d33",
  //         confirmButtonText: "ปิด",
  //       }).then((result) => {
  //         if (result.isConfirmed) {
  //           setOpen94(false);
  //           recheck94()
  //         }
  //       });
  //       return;
  //     } else if (!service94 || !selecttn94) {
  //       Swal.fire({
  //         icon: "warning",
  //         title: "คำเตือน",
  //         text: "กรุณาระบุหัตถการให้ถูกต้อง",
  //         showConfirmButton: false,
  //         timer: 2500,
  //       });
  //       return;
  //     }
  //     Swal.fire({
  //       title: "ยืนยันการนัดหมาย",
  //       icon: "info",
  //       showCancelButton: true,
  //       confirmButtonColor: "#3085d6",
  //       cancelButtonColor: "#d33",
  //       confirmButtonText: "ยืนยัน",
  //       cancelButtonText: "ยกเลิก",
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         addmanaappoinment94();
  //       }
  //     });
  //   });
  // };

  // //Modalsearch


  // const handleOpencancel94 = () => {
  //   Swal.fire({
  //     title: "ยกเลิกการเข้ารับบริการ",
  //     icon: "info",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "ยืนยัน",
  //     cancelButtonText: "ปิด",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       canceldataman(data9four.AN);
  //     }
  //   });
  // };


  //four

  //09:00

  //10:00
  //one
  const [data10one, setData10one] = useState([]);
  const [data10one2, setData10one2] = useState([]);
  const [editButton101, setEditButton101] = useState(false);
  const [icon101, setIcon101] = useState(<EventAvailable />);
  const [status101, setStatus101] = useState("ว่าง");
  const [cfer101, setCfer101] = useState(true);
  const [cancel101, setCancel101] = useState(true);

  useEffect(() => {
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data10one1 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "10:15",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "10:15",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinment/10/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata101 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            setData10one(data10one1[0]);
            setEditButton101(false);
            setIcon101(<EventAvailable />);
            setStatus101("ว่างงง");
            setCancel101(true);
            setCfer101(true);
            return;
          } else if (res.data.length >= 1) {
            setData10one(res.data[0]);
            setEditButton101(true);
            setIcon101(<EventBusy />);
            setStatus101("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata101[0] === 1 || resdata101[0] === 2) {
                setCfer101(true);
                setCancel101(true);
                return;
              } else if (resdata101[0] > 2 && resdata101[0] < 10) {
                setCfer101(true);
                setCancel101(false);
                return;
              } else if (resdata101[0] > 10) {
                setCfer101(false);
                setCancel101(false);
                return;
              } else {
                setCfer101(false);
                setCancel101(false);
                return;
              }
            } else {
              setCfer101(true);
              setCancel101(false);
              return;
            }
          }
        });
      } else {
        setData10one(data10one1[2]);
        setEditButton101(true);
        setIcon101(<EventBusy />);
        setStatus101("ไม่ว่าง");
        setCfer101(true);
        setCancel101(true);
        return;
      }
    });
  }, [startDate, data10one2, URL, time]);

  //Modalsearch

  const [selecttn101, setSelecttn101] = useState("");
  const [selectname101, setSelectname101] = useState("");
  const [service101, setService101] = useState("");

  const [provider101, setProvider101] = useState("หญิง");
  const handleChangeprovider101 = (event) => {
    setProvider101(event.target.value);
  };

  const handleChange101 = (event) => {
    setService101(event.target.value);
  };

  const selectpatient101 = (TN, prefix, fname, lname) => {
    setSelecttn101(TN);
    setSelectname101(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment101 = () => {
    var data = JSON.stringify({
      TN: selecttn101,
      date: data10one.date,
      time: data10one.time,
      service: service101,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 2500,
        }).then((result) => {
          recheck101();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen101(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck101 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinment/10/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData10one2(res.data[0]);
    });
  };

  const [open101, setOpen101] = useState(false);
  const handleOpen101 = () => setOpen101(true);
  const handleClose101 = () => setOpen101(false);

  const handleOpenin101 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinment/10/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen101(false);
            recheck101()
          }
        });
        return;
      } else if (!service101 || !selecttn101) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment101();
        }
      });
    });
  };

  //Modalsearch


  const handleOpencancel101 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldata(data10one.AN);
      }
    });
  };

  //one

  //two
  const [data10two, setData10two] = useState([]);
  const [data10two2, setData10two2] = useState([]);
  const [editButton102, setEditButton102] = useState(false);
  const [icon102, setIcon102] = useState(<EventAvailable />);
  const [status102, setStatus102] = useState("ว่าง");
  const [cfer102, setCfer102] = useState(true);
  const [cancel102, setCancel102] = useState(true);

  useEffect(() => {
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data10one2 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "10:15",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "10:15",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinments/10/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata102 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            setData10two(data10one2[0]);
            setEditButton102(false);
            setIcon102(<EventAvailable />);
            setStatus102("ว่างงง");
            setCancel102(true);
            setCfer102(true);
            return;
          } else if (res.data.length >= 1) {
            setData10two(res.data[0]);
            setEditButton102(true);
            setIcon102(<EventBusy />);
            setStatus102("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata102[0] === 1 || resdata102[0] === 2) {
                setCfer102(true);
                setCancel102(true);
                return;
              } else if (resdata102[0] > 2 && resdata102[0] < 10) {
                setCfer102(true);
                setCancel102(false);
                return;
              } else if (resdata102[0] > 10) {
                setCfer102(false);
                setCancel102(false);
                return;
              } else {
                setCfer102(false);
                setCancel102(false);
                return;
              }
            } else {
              setCfer102(true);
              setCancel102(false);
              return;
            }
          }
        });
      } else {
        setData10two(data10one2[2]);
        setEditButton102(true);
        setIcon102(<EventBusy />);
        setStatus102("ไม่ว่าง");
        setCfer102(true);
        setCancel102(true);
        return;
      }
    });
  }, [startDate, data10two2, URL, time]);

  //Modalsearch

  const [selecttn102, setSelecttn102] = useState("");
  const [selectname102, setSelectname102] = useState("");


  const [provider102, setProvider102] = useState("หญิง");
  const handleChangeprovider102 = (event) => {
    setProvider102(event.target.value);
  };

  const [service102, setService102] = useState("");
  const handleChange102 = (event) => {
    setService102(event.target.value);
  };

  const selectpatient102 = (TN, prefix, fname, lname) => {
    setSelecttn102(TN);
    setSelectname102(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment102 = () => {
    var data = JSON.stringify({
      TN: selecttn102,
      date: data10two.date,
      time: data10two.time,
      service: service102,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinmentss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck102();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen102(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck102 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinments/10/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData10two2(res.data[0]);
    });
  };

  const [open102, setOpen102] = useState(false);
  const handleOpen102 = () => setOpen102(true);
  const handleClose102 = () => setOpen102(false);

  const handleOpenin102 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinments/10/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen102(false);
            recheck102()
          }
        });
        return;
      } else if (!service102 || !selecttn102) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment102();
        }
      });
    });
  };

  //Modalsearch

  const handleOpencancel102 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldatas(data10two.AN);
      }
    });
  };


  //two

  //tree
  const [data10tree, setData10tree] = useState([]);
  const [data10tree2, setData10tree2] = useState([]);
  const [editButton103, setEditButton103] = useState(false);
  const [icon103, setIcon103] = useState(<EventAvailable />);
  const [status103, setStatus103] = useState("ว่าง");
  const [cfer103, setCfer103] = useState(true);
  const [cancel103, setCancel103] = useState(true);

  useEffect(() => {
    const roletoken = localStorage.getItem("role");
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data10one3 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "10:15",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "10:15",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinmentss/10/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata103 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            if (
              (startDate.getDay() === 0 || startDate.getDay() === 6) &&
              roletoken === "admin"
            ) {
              setData10tree(data10one3[1]);
              setEditButton103(true);
              setIcon103(<EventBusy />);
              setStatus103("ไม่ว่าง");
              setCfer103(true);
              setCancel103(true);
              return;
            }
            setData10tree(data10one3[0]);
            setEditButton103(false);
            setIcon103(<EventAvailable />);
            setStatus103("ว่างงง");
            setCancel103(true);
            setCfer103(true);
            return;
          } else if (res.data.length >= 1) {
            setData10tree(res.data[0]);
            setEditButton103(true);
            setIcon103(<EventBusy />);
            setStatus103("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata103[0] === 1 || resdata103[0] === 2) {
                setCfer103(true);
                setCancel103(true);
                return;
              } else if (resdata103[0] > 2 && resdata103[0] < 10) {
                setCfer103(true);
                setCancel103(false);
                return;
              } else if (resdata103[0] > 10) {
                setCfer103(false);
                setCancel103(false);
                return;
              } else {
                setCfer103(false);
                setCancel103(false);
                return;
              }
            } else {
              setCfer103(true);
              setCancel103(false);
              return;
            }
          }
        });
      } else {
        setData10tree(data10one3[2]);
        setEditButton103(true);
        setIcon103(<EventBusy />);
        setStatus103("ไม่ว่าง");
        setCfer103(true);
        setCancel103(true);
        return;
      }
    });
  }, [startDate, data10tree2, URL, time]);

  //Modalsearch

  const [selecttn103, setSelecttn103] = useState("");
  const [selectname103, setSelectname103] = useState("");
  const [service103, setService103] = useState("");

  const [provider103, setProvider103] = useState("หญิง");
  const handleChangeprovider103 = (event) => {
    setProvider103(event.target.value);
  };

  const handleChange103 = (event) => {
    setService103(event.target.value);
  };

  const selectpatient103 = (TN, prefix, fname, lname) => {
    setSelecttn103(TN);
    setSelectname103(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment103 = () => {
    var data = JSON.stringify({
      TN: selecttn103,
      date: data10tree.date,
      time: data10tree.time,
      service: service103,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinmentsss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck103();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen103(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck103 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentss/10/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData10tree2(res.data[0]);
    });
  };

  const [open103, setOpen103] = useState(false);
  const handleOpen103 = () => setOpen103(true);
  const handleClose103 = () => setOpen103(false);

  const handleOpenin103 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentss/10/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen103(false);
            recheck103()
          }
        });
        return;
      } else if (!service103 || !selecttn103) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment103();
        }
      });
    });
  };

  //Modalsearch


  const handleOpencancel103 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldatass(data10tree.AN);
      }
    });
  };

  //tree

  //five
  const [data10five, setData10five] = useState([]);
  const [data10five2, setData10five2] = useState([]);
  const [editButton105, setEditButton105] = useState(false);
  const [icon105, setIcon105] = useState(<EventAvailable />);
  const [status105, setStatus105] = useState("ว่าง");
  const [cfer105, setCfer105] = useState(true);
  const [cancel105, setCancel105] = useState(true);

  useEffect(() => {
    const roletoken = localStorage.getItem("role");
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data10one5 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "10:15",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "10:15",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinmentsss/10/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata105 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            if (
              (startDate.getDay() === 0 || startDate.getDay() === 6) &&
              roletoken === "admin"
            ) {
              setData10five(data10one5[1]);
              setEditButton105(true);
              setIcon105(<EventBusy />);
              setStatus105("ไม่ว่าง");
              setCfer105(true);
              setCancel105(true);
              return;
            }
            setData10five(data10one5[0]);
            setEditButton105(false);
            setIcon105(<EventAvailable />);
            setStatus105("ว่างงง");
            setCancel105(true);
            setCfer105(true);
            return;
          } else if (res.data.length >= 1) {
            setData10five(res.data[0]);
            setEditButton105(true);
            setIcon105(<EventBusy />);
            setStatus105("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata105[0] === 1 || resdata105[0] === 2) {
                setCfer105(true);
                setCancel105(true);
                return;
              } else if (resdata105[0] > 2 && resdata105[0] < 10) {
                setCfer105(true);
                setCancel105(false);
                return;
              } else if (resdata105[0] > 10) {
                setCfer105(false);
                setCancel105(false);
                return;
              } else {
                setCfer105(false);
                setCancel105(false);
                return;
              }
            } else {
              setCfer105(true);
              setCancel105(false);
              return;
            }
          }
        });
      } else {
        setData10five(data10one5[2]);
        setEditButton105(true);
        setIcon105(<EventBusy />);
        setStatus105("ไม่ว่าง");
        setCfer105(true);
        setCancel105(true);
        return;
      }
    });
  }, [startDate, data10five2, URL, time]);

  //Modalsearch

  const [selecttn105, setSelecttn105] = useState("");
  const [selectname105, setSelectname105] = useState("");

  const [provider105, setProvider105] = useState("หญิง");
  const handleChangeprovider105 = (event) => {
    setProvider105(event.target.value);
  };

  const [service105, setService105] = useState("");
  const handleChange105 = (event) => {
    setService105(event.target.value);
  };

  const selectpatient105 = (TN, prefix, fname, lname) => {
    setSelecttn105(TN);
    setSelectname105(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment105 = () => {
    var data = JSON.stringify({
      TN: selecttn105,
      date: data10five.date,
      time: data10five.time,
      service: service105,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinmentssss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck105();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen105(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck105 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentsss/10/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData10five2(res.data[0]);
    });
  };

  const [open105, setOpen105] = useState(false);
  const handleOpen105 = () => setOpen105(true);
  const handleClose105 = () => setOpen105(false);

  const handleOpenin105 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentsss/10/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen105(false);
            recheck105()
          }
        });
        return;
      } else if (!service105 || !selecttn105) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment105();
        }
      });
    });
  };

  //Modalsearch


  const handleOpencancel105 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldatasss(data10five.AN);
      }
    });
  };


  //five 




  //four


  // const [data10four, setData10four] = useState([]);
  // const [data10four2, setData10four2] = useState([]);
  // const [editButton104, setEditButton104] = useState(false);
  // const [icon104, setIcon104] = useState(<EventAvailable />);
  // const [status104, setStatus104] = useState("ว่าง");
  // const [cfer104, setCfer104] = useState(true);
  // const [cancel104, setCancel104] = useState(true);

  // useEffect(() => {
  //   const roletoken = localStorage.getItem("role");
  //   const dateInPast = function (firstDate, secondDate) {
  //     if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
  //       return true;
  //     }
  //     return false;
  //   };
  //   const bbb =
  //     startDate.getDate() +
  //     "-" +
  //     (startDate.getMonth() + 1) +
  //     "-" +
  //     startDate.getFullYear();
  //   const data10one4 = [
  //     {
  //       fname: "ว่าง",
  //       lname: null,
  //       service: "ว่าง",
  //       provider: "ชาย",
  //       date: bbb,
  //       time: "10:15",
  //       prefix: null,
  //     },
  //     {
  //       fname: null,
  //       lname: null,
  //       service: null,
  //       provider: null,
  //       date: null,
  //       time: null,
  //       prefix: null,
  //     },
  //     {
  //       AN: null,
  //       TN: null,
  //       fname: "ปิดบริการ",
  //       lname: "วันหยุดราชการ",
  //       service: "วันหยุดราชการหรืออื่นๆ",
  //       provider: "ชาย",
  //       date: bbb,
  //       time: "10:15",
  //       prefix: null,
  //     },
  //   ];
  //   const aaa = `${URL}/manappoinment/10/`;
  //   const oneURL = aaa + bbb;
  //   const holidaysURL = `${URL}/holidays`;
  //   axios.get(`${holidaysURL}`).then((res) => {
  //     const holidaysearch = startDate.toLocaleDateString("th-TH", {
  //       year: "numeric",
  //       month: "long",
  //       day: "numeric",
  //     });
  //     const holidays = res.data.map((item) => item.date);
  //     const arrayIncludes = holidays.includes(holidaysearch);
  //     if (arrayIncludes !== true) {
  //       axios.get(oneURL).then((res) => {
  //         const resdata104 = res.data.map((item) => {
  //           return item.TN;
  //         });
  //         if (res.data.length === 0) {
  //           if (
  //             (startDate.getDay() === 0 || startDate.getDay() === 6) &&
  //             roletoken === "admin"
  //           ) {
  //             setData10four(data10one4[1]);
  //             setEditButton104(true);
  //             setIcon104(<EventBusy />);
  //             setStatus104("ไม่ว่าง");
  //             setCfer104(true);
  //             setCancel104(true);
  //             return;
  //           }
  //           setData10four(data10one4[0]);
  //           setEditButton104(false);
  //           setIcon104(<EventAvailable />);
  //           setStatus104("ว่างงง");
  //           setCancel104(true);
  //           setCfer104(true);
  //           return;
  //         } else if (res.data.length >= 1) {
  //           setData10four(res.data[0]);
  //           setEditButton104(true);
  //           setIcon104(<EventBusy />);
  //           setStatus104("ไม่ว่าง");
  //           if (dateInPast(startDate, new Date())) {
  //             if (resdata104[0] === 1 || resdata104[0] === 2) {
  //               setCfer104(true);
  //               setCancel104(true);
  //               return;
  //             } else if (resdata104[0] > 2 && resdata104[0] < 10) {
  //               setCfer104(true);
  //               setCancel104(false);
  //               return;
  //             } else if (resdata104[0] > 10) {
  //               setCfer104(false);
  //               setCancel104(false);
  //               return;
  //             } else {
  //               setCfer104(false);
  //               setCancel104(false);
  //               return;
  //             }
  //           } else {
  //             setCfer104(true);
  //             setCancel104(false);
  //             return;
  //           }
  //         }
  //       });
  //     } else {
  //       setData10four(data10one4[2]);
  //       setEditButton104(true);
  //       setIcon104(<EventBusy />);
  //       setStatus104("ไม่ว่าง");
  //       setCfer104(true);
  //       setCancel104(true);
  //       return;
  //     }
  //   });
  // }, [startDate, data10four2, URL, time]);

  // //Modalsearch

  // const [selecttn104, setSelecttn104] = useState("");
  // const [selectname104, setSelectname104] = useState("");

  // const [provider104, setProvider104] = useState("ชาย");
  // const handleChangeprovider104 = (event) => {
  //   setProvider104(event.target.value);
  // };

  // const [service104, setService104] = useState("");
  // const handleChange104 = (event) => {
  //   setService104(event.target.value);
  // };

  // const selectpatient104 = (TN, prefix, fname, lname) => {
  //   setSelecttn104(TN);
  //   setSelectname104(`${prefix}${fname} ${lname}`);
  // };

  // const addmanaappoinment104 = () => {
  //   var data = JSON.stringify({
  //     TN: selecttn104,
  //     date: data10four.date,
  //     time: data10four.time,
  //     service: service104,
  //     provider: provider104,
  //   });

  //   var config = {
  //     method: "post",
  //     url: `${URL}/manapppoinment`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios(config)
  //     .then(function (response) {
  //       Swal.fire({
  //         icon: "success",
  //         title: "นัดหมายเรียบร้อย ",
  //         text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
  //         showConfirmButton: false,
  //         timer: 1500,
  //       }).then((result) => {
  //         recheck104();
  //         ldataall();
  //         ldatas();
  //         ldatass();
  //         ldatasss();
  //         ldataman();
  //         appdataone();
  //         appdatatwo();
  //         appdatatree();
  //         appdatafour();
  //         appdatafive();
  //         passappblock();
  //         passappconfirm();
  //         setOpen104(false);
  //       });
  //     })
  //     .catch(function (error) {
  //       alert(error);
  //     });
  // };

  // const recheck104 = () => {
  //   const bbb =
  //     startDate.getDate() +
  //     "-" +
  //     (startDate.getMonth() + 1) +
  //     "-" +
  //     startDate.getFullYear();
  //   const aaa = `${URL}/manappoinment/10/`;
  //   const oneURL = aaa + bbb;
  //   axios.get(oneURL).then((res) => {
  //     setData10four2(res.data[0]);
  //   });
  // };

  // const [open104, setOpen104] = useState(false);
  // const handleOpen104 = () => setOpen104(true);
  // const handleClose104 = () => setOpen104(false);

  // const handleOpenin104 = () => {
  //   const bbb =
  //     startDate.getDate() +
  //     "-" +
  //     (startDate.getMonth() + 1) +
  //     "-" +
  //     startDate.getFullYear();
  //   const aaa = `${URL}/manappoinment/10/`;
  //   const oneURL = aaa + bbb;
  //   axios.get(oneURL).then((res) => {
  //     if (res.data.length >= 1) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "เกิดข้อผิดพลาด",
  //         text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
  //         confirmButtonColor: "#d33",
  //         confirmButtonText: "ปิด",
  //       }).then((result) => {
  //         if (result.isConfirmed) {
  //           setOpen104(false);
  //           recheck104()
  //         }
  //       });
  //       return;
  //     } else if (!service104 || !selecttn104) {
  //       Swal.fire({
  //         icon: "warning",
  //         title: "คำเตือน",
  //         text: "กรุณาระบุหัตถการให้ถูกต้อง",
  //         showConfirmButton: false,
  //         timer: 2500,
  //       });
  //       return;
  //     }
  //     Swal.fire({
  //       title: "ยืนยันการนัดหมาย",
  //       icon: "info",
  //       showCancelButton: true,
  //       confirmButtonColor: "#3085d6",
  //       cancelButtonColor: "#d33",
  //       confirmButtonText: "ยืนยัน",
  //       cancelButtonText: "ยกเลิก",
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         addmanaappoinment104();
  //       }
  //     });
  //   });
  // };

  // //Modalsearch

  // const handleOpencancel104 = () => {
  //   Swal.fire({
  //     title: "ยกเลิกการเข้ารับบริการ",
  //     icon: "info",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "ยืนยัน",
  //     cancelButtonText: "ปิด",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       canceldataman(data10four.AN);
  //     }
  //   });
  // };



  //four

  //10:00

  //13:30

  //one
  const [data13one, setData13one] = useState([]);
  const [data13one2, setData13one2] = useState([]);
  const [editButton131, setEditButton131] = useState(false);
  const [icon131, setIcon131] = useState(<EventAvailable />);
  const [status131, setStatus131] = useState("ว่าง");
  const [cfer131, setCfer131] = useState(true);
  const [cancel131, setCancel131] = useState(true);

  useEffect(() => {
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data13one1 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "13:30",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "13:30",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinment/13/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata131 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            setData13one(data13one1[0]);
            setEditButton131(false);
            setIcon131(<EventAvailable />);
            setStatus131("ว่างงง");
            setCancel131(true);
            setCfer131(true);
            return;
          } else if (res.data.length >= 1) {
            setData13one(res.data[0]);
            setEditButton131(true);
            setIcon131(<EventBusy />);
            setStatus131("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata131[0] === 1 || resdata131[0] === 2) {
                setCfer131(true);
                setCancel131(true);
                return;
              } else if (resdata131[0] > 2 && resdata131[0] < 10) {
                setCfer131(true);
                setCancel131(false);
                return;
              } else if (resdata131[0] > 10) {
                setCfer131(false);
                setCancel131(false);
                return;
              } else {
                setCfer131(false);
                setCancel131(false);
                return;
              }
            } else {
              setCfer131(true);
              setCancel131(false);
              return;
            }
          }
        });
      } else {
        setData13one(data13one1[2]);
        setEditButton131(true);
        setIcon131(<EventBusy />);
        setStatus131("ไม่ว่าง");
        setCfer131(true);
        setCancel131(true);
        return;
      }
    });
  }, [startDate, data13one2, URL, time]);

  //Modalsearch

  const [selecttn131, setSelecttn131] = useState("");
  const [selectname131, setSelectname131] = useState("");

  const [provider131, setProvider131] = useState("หญิง");
  const handleChangeprovider131 = (event) => {
    setProvider131(event.target.value);
  };

  const [service131, setService131] = useState("");
  const handleChange131 = (event) => {
    setService131(event.target.value);
  };

  const selectpatient131 = (TN, prefix, fname, lname) => {
    setSelecttn131(TN);
    setSelectname131(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment131 = () => {
    var data = JSON.stringify({
      TN: selecttn131,
      date: data13one.date,
      time: data13one.time,
      service: service131,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck131();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen131(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck131 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinment/13/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData13one2(res.data[0]);
    });
  };

  const [open131, setOpen131] = useState(false);
  const handleOpen131 = () => setOpen131(true);
  const handleClose131 = () => setOpen131(false);

  const handleOpenin131 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinment/13/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen131(false);
            recheck131()
          }
        });
        return;
      } else if (!service131 || !selecttn131) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment131();
        }
      });
    });
  };

  //Modalsearch

  const handleOpencancel131 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldata(data13one.AN);
      }
    });
  };


  //one

  //two
  const [data13two, setData13two] = useState([]);
  const [data13two2, setData13two2] = useState([]);
  const [editButton132, setEditButton132] = useState(false);
  const [icon132, setIcon132] = useState(<EventAvailable />);
  const [status132, setStatus132] = useState("ว่าง");
  const [cfer132, setCfer132] = useState(true);
  const [cancel132, setCancel132] = useState(true);

  useEffect(() => {
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data13one2 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "13:30",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "13:30",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinments/13/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata132 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            setData13two(data13one2[0]);
            setEditButton132(false);
            setIcon132(<EventAvailable />);
            setStatus132("ว่างงง");
            setCancel132(true);
            setCfer132(true);
            return;
          } else if (res.data.length >= 1) {
            setData13two(res.data[0]);
            setEditButton132(true);
            setIcon132(<EventBusy />);
            setStatus132("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata132[0] === 1 || resdata132[0] === 2) {
                setCfer132(true);
                setCancel132(true);
                return;
              } else if (resdata132[0] > 2 && resdata132[0] < 10) {
                setCfer132(true);
                setCancel132(false);
                return;
              } else if (resdata132[0] > 10) {
                setCfer132(false);
                setCancel132(false);
                return;
              } else {
                setCfer132(false);
                setCancel132(false);
                return;
              }
            } else {
              setCfer132(true);
              setCancel132(false);
              return;
            }
          }
        });
      } else {
        setData13two(data13one2[2]);
        setEditButton132(true);
        setIcon132(<EventBusy />);
        setStatus132("ไม่ว่าง");
        setCfer132(true);
        setCancel132(true);
        return;
      }
    });
  }, [startDate, data13two2, URL, time]);

  //Modalsearch

  const [selecttn132, setSelecttn132] = useState("");
  const [selectname132, setSelectname132] = useState("");

  const [provider132, setProvider132] = useState("หญิง");
  const handleChangeprovider132 = (event) => {
    setProvider132(event.target.value);
  };

  const [service132, setService132] = useState("");
  const handleChange132 = (event) => {
    setService132(event.target.value);
  };

  const selectpatient132 = (TN, prefix, fname, lname) => {
    setSelecttn132(TN);
    setSelectname132(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment132 = () => {
    var data = JSON.stringify({
      TN: selecttn132,
      date: data13two.date,
      time: data13two.time,
      service: service132,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinmentss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck132();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen132(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck132 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinments/13/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData13two2(res.data[0]);
    });
  };

  const [open132, setOpen132] = useState(false);
  const handleOpen132 = () => setOpen132(true);
  const handleClose132 = () => setOpen132(false);

  const handleOpenin132 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinments/13/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen132(false);
            recheck132()
          }
        });
        return;
      } else if (!service132 || !selecttn132) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment132();
        }
      });
    });
  };

  //Modalsearch

  const handleOpencancel132 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldatas(data13two.AN);
      }
    });
  };


  //two

  //tree
  const [data13tree, setData13tree] = useState([]);
  const [data13tree2, setData13tree2] = useState([]);
  const [editButton133, setEditButton133] = useState(false);
  const [icon133, setIcon133] = useState(<EventAvailable />);
  const [status133, setStatus133] = useState("ว่าง");
  const [cfer133, setCfer133] = useState(true);
  const [cancel133, setCancel133] = useState(true);

  useEffect(() => {
    const roletoken = localStorage.getItem("role");
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data13one3 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "13:30",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "13:30",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinmentss/13/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata133 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            if (
              (startDate.getDay() === 0 || startDate.getDay() === 6) &&
              roletoken === "admin"
            ) {
              setData13tree(data13one3[1]);
              setEditButton133(true);
              setIcon133(<EventBusy />);
              setStatus133("ไม่ว่าง");
              setCfer133(true);
              setCancel133(true);
              return;
            }
            setData13tree(data13one3[0]);
            setEditButton133(false);
            setIcon133(<EventAvailable />);
            setStatus133("ว่างงง");
            setCancel133(true);
            setCfer133(true);
            return;
          } else if (res.data.length >= 1) {
            setData13tree(res.data[0]);
            setEditButton133(true);
            setIcon133(<EventAvailable />);
            setStatus133("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata133[0] === 1 || resdata133[0] === 2) {
                setCfer133(true);
                setCancel133(true);
                return;
              } else if (resdata133[0] > 2 && resdata133[0] < 10) {
                setCfer133(true);
                setCancel133(false);
                return;
              } else if (resdata133[0] > 10) {
                setCfer133(false);
                setCancel133(false);
                return;
              } else {
                setCfer133(false);
                setCancel133(false);
                return;
              }
            } else {
              setCfer133(true);
              setCancel133(false);
              return;
            }
          }
        });
      } else {
        setData13tree(data13one3[2]);
        setEditButton133(true);
        setIcon133(<EventBusy />);
        setStatus133("ไม่ว่าง");
        setCfer133(true);
        setCancel133(true);
        return;
      }
    });
  }, [startDate, data13tree2, URL, time]);

  //Modalsearch

  const [selecttn133, setSelecttn133] = useState("");
  const [selectname133, setSelectname133] = useState("");

  const [provider133, setProvider133] = useState("หญิง");
  const handleChangeprovider133 = (event) => {
    setProvider133(event.target.value);
  };

  const [service133, setService133] = useState("");
  const handleChange133 = (event) => {
    setService133(event.target.value);
  };

  const selectpatient133 = (TN, prefix, fname, lname) => {
    setSelecttn133(TN);
    setSelectname133(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment133 = () => {
    var data = JSON.stringify({
      TN: selecttn133,
      date: data13tree.date,
      time: data13tree.time,
      service: service133,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinmentsss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck133();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen133(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck133 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentss/13/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData13tree2(res.data[0]);
    });
  };

  const [open133, setOpen133] = useState(false);
  const handleOpen133 = () => setOpen133(true);
  const handleClose133 = () => setOpen133(false);

  const handleOpenin133 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentss/13/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen133(false);
            recheck133()
          }
        });
        return;
      } else if (!service133 || !selecttn133) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment133();
        }
      });
    });
  };

  //Modalsearch
  const handleOpencancel133 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldatass(data13tree.AN);
      }
    });
  };


  //tree

  //five
  const [data13five, setData13five] = useState([]);
  const [data13five2, setData13five2] = useState([]);
  const [editButton135, setEditButton135] = useState(false);
  const [icon135, setIcon135] = useState(<EventAvailable />);
  const [status135, setStatus135] = useState("ว่าง");
  const [cfer135, setCfer135] = useState(true);
  const [cancel135, setCancel135] = useState(true);

  useEffect(() => {
    const roletoken = localStorage.getItem("role");
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data13one5 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "13:30",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "13:30",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinmentsss/13/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata135 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            if (
              (startDate.getDay() === 0 || startDate.getDay() === 6) &&
              roletoken === "admin"
            ) {
              setData13five(data13one5[1]);
              setEditButton135(true);
              setIcon135(<EventBusy />);
              setStatus135("ไม่ว่าง");
              setCfer135(true);
              setCancel135(true);
              return;
            }
            setData13five(data13one5[0]);
            setEditButton135(false);
            setIcon135(<EventAvailable />);
            setStatus135("ว่างงง");
            setCancel135(true);
            setCfer135(true);
            return;
          } else if (res.data.length >= 1) {
            setData13five(res.data[0]);
            setEditButton135(true);
            setIcon135(<EventAvailable />);
            setStatus135("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata135[0] === 1 || resdata135[0] === 2) {
                setCfer135(true);
                setCancel135(true);
                return;
              } else if (resdata135[0] > 2 && resdata135[0] < 10) {
                setCfer135(true);
                setCancel135(false);
                return;
              } else if (resdata135[0] > 10) {
                setCfer135(false);
                setCancel135(false);
                return;
              } else {
                setCfer135(false);
                setCancel135(false);
                return;
              }
            } else {
              setCfer135(true);
              setCancel135(false);
              return;
            }
          }
        });
      } else {
        setData13five(data13one5[2]);
        setEditButton135(true);
        setIcon135(<EventBusy />);
        setStatus135("ไม่ว่าง");
        setCfer135(true);
        setCancel135(true);
        return;
      }
    });
  }, [startDate, data13five2, URL, time]);

  //Modalsearch

  const [selecttn135, setSelecttn135] = useState("");
  const [selectname135, setSelectname135] = useState("");

  const [provider135, setProvider135] = useState("หญิง");
  const handleChangeprovider135 = (event) => {
    setProvider135(event.target.value);
  };

  const [service135, setService135] = useState("");
  const handleChange135 = (event) => {
    setService135(event.target.value);
  };

  const selectpatient135 = (TN, prefix, fname, lname) => {
    setSelecttn135(TN);
    setSelectname135(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment135 = () => {
    var data = JSON.stringify({
      TN: selecttn135,
      date: data13five.date,
      time: data13five.time,
      service: service135,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinmentssss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck135();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen135(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck135 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentsss/13/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData13five2(res.data[0]);
    });
  };

  const [open135, setOpen135] = useState(false);
  const handleOpen135 = () => setOpen135(true);
  const handleClose135 = () => setOpen135(false);

  const handleOpenin135 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentsss/13/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen135(false);
            recheck135()
          }
        });
        return;
      } else if (!service135 || !selecttn135) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment135();
        }
      });
    });
  };

  //Modalsearch

  const handleOpencancel135 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldatasss(data13five.AN);
      }
    });
  };

  //five


  //four


  // const [data13four, setData13four] = useState([]);
  // const [data13four2, setData13four2] = useState([]);
  // const [editButton134, setEditButton134] = useState(false);
  // const [icon134, setIcon134] = useState(<EventAvailable />);
  // const [status134, setStatus134] = useState("ว่าง");
  // const [cfer134, setCfer134] = useState(true);
  // const [cancel134, setCancel134] = useState(true);

  // useEffect(() => {
  //   const roletoken = localStorage.getItem("role");
  //   const dateInPast = function (firstDate, secondDate) {
  //     if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
  //       return true;
  //     }
  //     return false;
  //   };
  //   const bbb =
  //     startDate.getDate() +
  //     "-" +
  //     (startDate.getMonth() + 1) +
  //     "-" +
  //     startDate.getFullYear();
  //   const data13one4 = [
  //     {
  //       fname: "ว่าง",
  //       lname: null,
  //       service: "ว่าง",
  //       provider: "ชาย",
  //       date: bbb,
  //       time: "13:30",
  //       prefix: null,
  //     },
  //     {
  //       fname: null,
  //       lname: null,
  //       service: null,
  //       provider: null,
  //       date: null,
  //       time: null,
  //       prefix: null,
  //     },
  //     {
  //       AN: null,
  //       TN: null,
  //       fname: "ปิดบริการ",
  //       lname: "วันหยุดราชการ",
  //       service: "วันหยุดราชการหรืออื่นๆ",
  //       provider: "ชาย",
  //       date: bbb,
  //       time: "13:30",
  //       prefix: null,
  //     },
  //   ];
  //   const aaa = `${URL}/manappoinment/13/`;
  //   const oneURL = aaa + bbb;
  //   const holidaysURL = `${URL}/holidays`;
  //   axios.get(`${holidaysURL}`).then((res) => {
  //     const holidaysearch = startDate.toLocaleDateString("th-TH", {
  //       year: "numeric",
  //       month: "long",
  //       day: "numeric",
  //     });
  //     const holidays = res.data.map((item) => item.date);
  //     const arrayIncludes = holidays.includes(holidaysearch);
  //     if (arrayIncludes !== true) {
  //       axios.get(oneURL).then((res) => {
  //         const resdata134 = res.data.map((item) => {
  //           return item.TN;
  //         });
  //         if (res.data.length === 0) {
  //           if (
  //             (startDate.getDay() === 0 || startDate.getDay() === 6) &&
  //             roletoken === "admin"
  //           ) {
  //             setData13four(data13one4[1]);
  //             setEditButton134(true);
  //             setIcon134(<EventBusy />);
  //             setStatus134("ไม่ว่าง");
  //             setCfer134(true);
  //             setCancel134(true);
  //             return;
  //           }
  //           setData13four(data13one4[0]);
  //           setEditButton134(false);
  //           setIcon134(<EventAvailable />);
  //           setStatus134("ว่างงง");
  //           setCancel134(true);
  //           setCfer134(true);
  //           return;
  //         } else if (res.data.length >= 1) {
  //           setData13four(res.data[0]);
  //           setEditButton134(true);
  //           setIcon134(<EventBusy />);
  //           setStatus134("ไม่ว่าง");
  //           if (dateInPast(startDate, new Date())) {
  //             if (resdata134[0] === 1 || resdata134[0] === 2) {
  //               setCfer134(true);
  //               setCancel134(true);
  //               return;
  //             } else if (resdata134[0] > 2 && resdata134[0] < 10) {
  //               setCfer134(true);
  //               setCancel134(false);
  //               return;
  //             } else if (resdata134[0] > 10) {
  //               setCfer134(false);
  //               setCancel134(false);
  //               return;
  //             } else {
  //               setCfer134(false);
  //               setCancel134(false);
  //               return;
  //             }
  //           } else {
  //             setCfer134(true);
  //             setCancel134(false);
  //             return;
  //           }
  //         }
  //       });
  //     } else {
  //       setData13four(data13one4[2]);
  //       setEditButton134(true);
  //       setIcon134(<EventBusy />);
  //       setStatus134("ไม่ว่าง");
  //       setCfer134(true);
  //       setCancel134(true);
  //       return;
  //     }
  //   });
  // }, [startDate, data13four2, URL, time]);

  // //Modalsearch

  // const [selecttn134, setSelecttn134] = useState("");
  // const [selectname134, setSelectname134] = useState("");

  // const [provider134, setProvider134] = useState("ชาย");
  // const handleChangeprovider134 = (event) => {
  //   setProvider134(event.target.value);
  // };

  // const [service134, setService134] = useState("");
  // const handleChange134 = (event) => {
  //   setService134(event.target.value);
  // };

  // const selectpatient134 = (TN, prefix, fname, lname) => {
  //   setSelecttn134(TN);
  //   setSelectname134(`${prefix}${fname} ${lname}`);
  // };

  // const addmanaappoinment134 = () => {
  //   var data = JSON.stringify({
  //     TN: selecttn134,
  //     date: data13four.date,
  //     time: data13four.time,
  //     service: service134,
  //     provider: provider134,
  //   });

  //   var config = {
  //     method: "post",
  //     url: `${URL}/manapppoinment`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios(config)
  //     .then(function (response) {
  //       Swal.fire({
  //         icon: "success",
  //         title: "นัดหมายเรียบร้อย ",
  //         text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
  //         showConfirmButton: false,
  //         timer: 1500,
  //       }).then((result) => {
  //         recheck134();
  //         ldataall();
  //         ldatas();
  //         ldatass();
  //         ldatasss();
  //         ldataman();
  //         appdataone();
  //         appdatatwo();
  //         appdatatree();
  //         appdatafour();
  //         appdatafive();
  //         passappblock();
  //         passappconfirm();
  //         setOpen134(false);
  //       });
  //     })
  //     .catch(function (error) {
  //       alert(error);
  //     });
  // };

  // const recheck134 = () => {
  //   const bbb =
  //     startDate.getDate() +
  //     "-" +
  //     (startDate.getMonth() + 1) +
  //     "-" +
  //     startDate.getFullYear();
  //   const aaa = `${URL}/manappoinment/13/`;
  //   const oneURL = aaa + bbb;
  //   axios.get(oneURL).then((res) => {
  //     setData13four2(res.data[0]);
  //   });
  // };

  // const [open134, setOpen134] = useState(false);
  // const handleOpen134 = () => setOpen134(true);
  // const handleClose134 = () => setOpen134(false);

  // const handleOpenin134 = () => {
  //   const bbb =
  //     startDate.getDate() +
  //     "-" +
  //     (startDate.getMonth() + 1) +
  //     "-" +
  //     startDate.getFullYear();
  //   const aaa = `${URL}/manappoinment/13/`;
  //   const oneURL = aaa + bbb;
  //   axios.get(oneURL).then((res) => {
  //     if (res.data.length >= 1) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "เกิดข้อผิดพลาด",
  //         text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
  //         confirmButtonColor: "#d33",
  //         confirmButtonText: "ปิด",
  //       }).then((result) => {
  //         if (result.isConfirmed) {
  //           setOpen134(false);
  //           recheck134()
  //         }
  //       });
  //       return;
  //     } else if (!service134 || !selecttn134) {
  //       Swal.fire({
  //         icon: "warning",
  //         title: "คำเตือน",
  //         text: "กรุณาระบุหัตถการให้ถูกต้อง",
  //         showConfirmButton: false,
  //         timer: 2500,
  //       });
  //       return;
  //     }
  //     Swal.fire({
  //       title: "ยืนยันการนัดหมาย",
  //       icon: "info",
  //       showCancelButton: true,
  //       confirmButtonColor: "#3085d6",
  //       cancelButtonColor: "#d33",
  //       confirmButtonText: "ยืนยัน",
  //       cancelButtonText: "ยกเลิก",
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         addmanaappoinment134();
  //       }
  //     });
  //   });
  // };

  // //Modalsearch

  // const handleOpencancel134 = () => {
  //   Swal.fire({
  //     title: "ยกเลิกการเข้ารับบริการ",
  //     icon: "info",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "ยืนยัน",
  //     cancelButtonText: "ปิด",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       canceldataman(data13four.AN);
  //     }
  //   });
  // };



  //four

  //13:30

  //14:45
  //one
  const [data14one, setData14one] = useState([]);
  const [data14one2, setData14one2] = useState([]);
  const [editButton141, setEditButton141] = useState(false);
  const [icon141, setIcon141] = useState(<EventAvailable />);
  const [status141, setStatus141] = useState("ว่าง");
  const [cfer141, setCfer141] = useState(true);
  const [cancel141, setCancel141] = useState(true);

  useEffect(() => {
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const roletoken = localStorage.getItem("role");
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data14one1 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "14:45",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "14:45",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinment/14/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata141 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            if (
              (startDate.getDay() === 0 || startDate.getDay() === 6) &&
              roletoken === "admin"
            ) {
              setData14one(data14one1[1]);
              setEditButton141(true);
              setIcon141(<EventBusy />);
              setStatus141("ไม่ว่าง");
              setCfer141(true);
              setCancel141(true);
              return;
            }
            setData14one(data14one1[0]);
            setEditButton141(false);
            setIcon141(<EventAvailable />);
            setStatus141("ว่างงง");
            setCancel141(true);
            setCfer141(true);
            return;
          } else if (res.data.length >= 1) {
            setData14one(res.data[0]);
            setEditButton141(true);
            setIcon141(<EventBusy />);
            setStatus141("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata141[0] === 1 || resdata141[0] === 2) {
                setCfer141(true);
                setCancel141(true);
                return;
              } else if (resdata141[0] > 2 && resdata141[0] < 10) {
                setCfer141(true);
                setCancel141(false);
                return;
              } else if (resdata141[0] > 10) {
                setCfer141(false);
                setCancel141(false);
                return;
              } else {
                setCfer141(false);
                setCancel141(false);
                return;
              }
            } else {
              setCfer141(true);
              setCancel141(false);
              return;
            }
          }
        });
      } else {
        setData14one(data14one1[2]);
        setEditButton141(true);
        setIcon141(<EventBusy />);
        setStatus141("ไม่ว่าง");
        setCfer141(true);
        setCancel141(true);
        return;
      }
    });
  }, [startDate, data14one2, URL, time]);

  //Modalsearch

  const [selecttn141, setSelecttn141] = useState("");
  const [selectname141, setSelectname141] = useState("");

  const [provider141, setProvider141] = useState("หญิง");
  const handleChangeprovider141 = (event) => {
    setProvider141(event.target.value);
  };

  const [service141, setService141] = useState("");
  const handleChange141 = (event) => {
    setService141(event.target.value);
  };

  const selectpatient141 = (TN, prefix, fname, lname) => {
    setSelecttn141(TN);
    setSelectname141(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment141 = () => {
    var data = JSON.stringify({
      TN: selecttn141,
      date: data14one.date,
      time: data14one.time,
      service: service141,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck141();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen141(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck141 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinment/14/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData14one2(res.data[0]);
    });
  };

  const [open141, setOpen141] = useState(false);
  const handleOpen141 = () => setOpen141(true);
  const handleClose141 = () => setOpen141(false);

  const handleOpenin141 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinment/14/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen141(false);
            recheck141()
          }
        });
        return;
      } else if (!service141 || !selecttn141) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment141();
        }
      });
    });
  };

  //Modalsearch

  const handleOpencancel141 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldata(data14one.AN);
      }
    });
  };


  //one

  //two
  const [data14two, setData14two] = useState([]);
  const [data14two2, setData14two2] = useState([]);
  const [editButton142, setEditButton142] = useState(false);
  const [icon142, setIcon142] = useState(<EventAvailable />);
  const [status142, setStatus142] = useState("ว่าง");
  const [cfer142, setCfer142] = useState(true);
  const [cancel142, setCancel142] = useState(true);

  useEffect(() => {
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const roletoken = localStorage.getItem("role");
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data14one2 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "14:45",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "14:45",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinments/14/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata142 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            if (
              (startDate.getDay() === 0 || startDate.getDay() === 6) &&
              roletoken === "admin"
            ) {
              setData14two(data14one2[1]);
              setEditButton142(true);
              setIcon142(<EventBusy />);
              setStatus142("ไม่ว่าง");
              setCfer142(true);
              setCancel142(true);
              return;
            }
            setData14two(data14one2[0]);
            setEditButton142(false);
            setIcon142(<EventAvailable />);
            setStatus142("ว่างงง");
            setCancel142(true);
            setCfer142(true);
            return;
          } else if (res.data.length >= 1) {
            setData14two(res.data[0]);
            setEditButton142(true);
            setIcon142(<EventBusy />);
            setStatus142("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata142[0] === 1 || resdata142[0] === 2) {
                setCfer142(true);
                setCancel142(true);
                return;
              } else if (resdata142[0] > 2 && resdata142[0] < 10) {
                setCfer142(true);
                setCancel142(false);
                return;
              } else if (resdata142[0] > 10) {
                setCfer142(false);
                setCancel142(false);
                return;
              } else {
                setCfer142(false);
                setCancel142(false);
                return;
              }
            } else {
              setCfer142(true);
              setCancel142(false);
              return;
            }
          }
        });
      } else {
        setData14two(data14one2[2]);
        setEditButton142(true);
        setIcon142(<EventBusy />);
        setStatus142("ไม่ว่าง");
        setCfer142(true);
        setCancel142(true);
        return;
      }
    });
  }, [startDate, data14two2, URL, time]);

  //Modalsearch

  const [selecttn142, setSelecttn142] = useState("");
  const [selectname142, setSelectname142] = useState("");

  const [provider142, setProvider142] = useState("หญิง");
  const handleChangeprovider142 = (event) => {
    setProvider142(event.target.value);
  };

  const [service142, setService142] = useState("");
  const handleChange142 = (event) => {
    setService142(event.target.value);
  };

  const selectpatient142 = (TN, prefix, fname, lname) => {
    setSelecttn142(TN);
    setSelectname142(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment142 = () => {
    var data = JSON.stringify({
      TN: selecttn142,
      date: data14two.date,
      time: data14two.time,
      service: service142,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinmentss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck142();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen142(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck142 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinments/14/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData14two2(res.data[0]);
    });
  };

  const [open142, setOpen142] = useState(false);
  const handleOpen142 = () => setOpen142(true);
  const handleClose142 = () => setOpen142(false);

  const handleOpenin142 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinments/14/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen142(false);
            recheck142()
          }
        });
        return;
      } else if (!service142 || !selecttn142) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment142();
        }
      });
    });
  };

  //Modalsearch


  const handleOpencancel142 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldatas(data14two.AN);
      }
    });
  };


  //two

  //tree
  const [data14tree, setData14tree] = useState([]);
  const [data14tree2, setData14tree2] = useState([]);
  const [editButton143, setEditButton143] = useState(false);
  const [icon143, setIcon143] = useState(<EventAvailable />);
  const [status143, setStatus143] = useState("ว่าง");
  const [cfer143, setCfer143] = useState(true);
  const [cancel143, setCancel143] = useState(true);

  useEffect(() => {
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const roletoken = localStorage.getItem("role");
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data14one3 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "14:45",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "14:45",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinmentss/14/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata143 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            if (
              (startDate.getDay() === 0 || startDate.getDay() === 6) &&
              roletoken === "admin"
            ) {
              setData14tree(data14one3[1]);
              setEditButton143(true);
              setIcon143(<EventBusy />);
              setStatus143("ไม่ว่าง");
              setCfer143(true);
              setCancel143(true);
              return;
            }
            setData14tree(data14one3[0]);
            setEditButton143(false);
            setIcon143(<EventAvailable />);
            setStatus143("ว่างงง");
            setCancel143(true);
            setCfer143(true);
            return;
          } else if (res.data.length >= 1) {
            setData14tree(res.data[0]);
            setEditButton143(true);
            setIcon143(<EventBusy />);
            setStatus143("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata143[0] === 1 || resdata143[0] === 2) {
                setCfer143(true);
                setCancel143(true);
                return;
              } else if (resdata143[0] > 2 && resdata143[0] < 10) {
                setCfer143(true);
                setCancel143(false);
                return;
              } else if (resdata143[0] > 10) {
                setCfer143(false);
                setCancel143(false);
                return;
              } else {
                setCfer143(false);
                setCancel143(false);
                return;
              }
            } else {
              setCfer143(true);
              setCancel143(false);
              return;
            }
          }
        });
      } else {
        setData14tree(data14one3[2]);
        setEditButton143(true);
        setIcon143(<EventBusy />);
        setStatus143("ไม่ว่าง");
        setCfer143(true);
        setCancel143(true);
        return;
      }
    });
  }, [startDate, data14tree2, URL, time]);

  //Modalsearch

  const [selecttn143, setSelecttn143] = useState("");
  const [selectname143, setSelectname143] = useState("");

  const [provider143, setProvider143] = useState("หญิง");
  const handleChangeprovider143 = (event) => {
    setProvider143(event.target.value);
  };

  const [service143, setService143] = useState("");
  const handleChange143 = (event) => {
    setService143(event.target.value);
  };

  const selectpatient143 = (TN, prefix, fname, lname) => {
    setSelecttn143(TN);
    setSelectname143(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment143 = () => {
    var data = JSON.stringify({
      TN: selecttn143,
      date: data14tree.date,
      time: data14tree.time,
      service: service143,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinmentsss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck143();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen143(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck143 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentss/14/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData14tree2(res.data[0]);
    });
  };

  const [open143, setOpen143] = useState(false);
  const handleOpen143 = () => setOpen143(true);
  const handleClose143 = () => setOpen143(false);

  const handleOpenin143 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentss/14/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen143(false);
            recheck143()
          }
        });
        return;
      } else if (!service143 || !selecttn143) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment143();
        }
      });
    });
  };

  //Modalsearch


  const handleOpencancel143 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldatass(data14tree.AN);
      }
    });
  };


  //tree

  //five
  const [data14five, setData14five] = useState([]);
  const [data14five2, setData14five2] = useState([]);
  const [editButton145, setEditButton145] = useState(false);
  const [icon145, setIcon145] = useState(<EventAvailable />);
  const [status145, setStatus145] = useState("ว่าง");
  const [cfer145, setCfer145] = useState(true);
  const [cancel145, setCancel145] = useState(true);

  useEffect(() => {
    const dateInPast = function (firstDate, secondDate) {
      if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    };
    const roletoken = localStorage.getItem("role");
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const data14one5 = [
      {
        fname: "ว่าง",
        lname: null,
        service: "ว่าง",
        provider: "หญิง",
        date: bbb,
        time: "14:45",
        prefix: null,
      },
      {
        fname: null,
        lname: null,
        service: null,
        provider: null,
        date: null,
        time: null,
        prefix: null,
      },
      {
        AN: null,
        TN: null,
        fname: "ปิดบริการ",
        lname: "วันหยุดราชการ",
        service: "วันหยุดราชการหรืออื่นๆ",
        provider: "หญิง",
        date: bbb,
        time: "14:45",
        prefix: null,
      },
    ];
    const aaa = `${URL}/appoinmentsss/14/`;
    const oneURL = aaa + bbb;
    const holidaysURL = `${URL}/holidays`;
    axios.get(`${holidaysURL}`).then((res) => {
      const holidaysearch = startDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const holidays = res.data.map((item) => item.date);
      const arrayIncludes = holidays.includes(holidaysearch);
      if (arrayIncludes !== true) {
        axios.get(oneURL).then((res) => {
          const resdata145 = res.data.map((item) => {
            return item.TN;
          });
          if (res.data.length === 0) {
            if (
              (startDate.getDay() === 0 || startDate.getDay() === 6) &&
              roletoken === "admin"
            ) {
              setData14five(data14one5[1]);
              setEditButton145(true);
              setIcon145(<EventBusy />);
              setStatus145("ไม่ว่าง");
              setCfer145(true);
              setCancel145(true);
              return;
            }
            setData14five(data14one5[0]);
            setEditButton145(false);
            setIcon145(<EventAvailable />);
            setStatus145("ว่างงง");
            setCancel145(true);
            setCfer145(true);
            return;
          } else if (res.data.length >= 1) {
            setData14five(res.data[0]);
            setEditButton145(true);
            setIcon145(<EventBusy />);
            setStatus145("ไม่ว่าง");
            if (dateInPast(startDate, new Date())) {
              if (resdata145[0] === 1 || resdata145[0] === 2) {
                setCfer145(true);
                setCancel145(true);
                return;
              } else if (resdata145[0] > 2 && resdata145[0] < 10) {
                setCfer145(true);
                setCancel145(false);
                return;
              } else if (resdata145[0] > 10) {
                setCfer145(false);
                setCancel145(false);
                return;
              } else {
                setCfer145(false);
                setCancel145(false);
                return;
              }
            } else {
              setCfer145(true);
              setCancel145(false);
              return;
            }
          }
        });
      } else {
        setData14five(data14one5[2]);
        setEditButton145(true);
        setIcon145(<EventBusy />);
        setStatus145("ไม่ว่าง");
        setCfer145(true);
        setCancel145(true);
        return;
      }
    });
  }, [startDate, data14five2, URL, time]);

  //Modalsearch

  const [selecttn145, setSelecttn145] = useState("");
  const [selectname145, setSelectname145] = useState("");

  const [provider145, setProvider145] = useState("หญิง");
  const handleChangeprovider145 = (event) => {
    setProvider145(event.target.value);
  };

  const [service145, setService145] = useState("");
  const handleChange145 = (event) => {
    setService145(event.target.value);
  };

  const selectpatient145 = (TN, prefix, fname, lname) => {
    setSelecttn145(TN);
    setSelectname145(`${prefix}${fname} ${lname}`);
  };

  const addmanaappoinment145 = () => {
    var data = JSON.stringify({
      TN: selecttn145,
      date: data14five.date,
      time: data14five.time,
      service: service145,
      provider: "หญิง",
    });

    var config = {
      method: "post",
      url: `${URL}/apppoinmentssss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "นัดหมายเรียบร้อย ",
          text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          recheck145();
          ldataall();
          ldatas();
          ldatass();
          ldatasss();
          ldataman();
          appdataone();
          appdatatwo();
          appdatatree();
          appdatafour();
          appdatafive();
          passappblock();
          passappconfirm();
          setOpen145(false);
        });
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const recheck145 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentsss/14/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      setData14five2(res.data[0]);
    });
  };

  const [open145, setOpen145] = useState(false);
  const handleOpen145 = () => setOpen145(true);
  const handleClose145 = () => setOpen145(false);

  const handleOpenin145 = () => {
    const bbb =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const aaa = `${URL}/appoinmentsss/14/`;
    const oneURL = aaa + bbb;
    axios.get(oneURL).then((res) => {
      if (res.data.length >= 1) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
          confirmButtonColor: "#d33",
          confirmButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            setOpen145(false);
            recheck145()
          }
        });
        return;
      } else if (!service145 || !selecttn145) {
        Swal.fire({
          icon: "warning",
          title: "คำเตือน",
          text: "กรุณาระบุหัตถการให้ถูกต้อง",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      Swal.fire({
        title: "ยืนยันการนัดหมาย",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          addmanaappoinment145();
        }
      });
    });
  };

  //Modalsearch


  const handleOpencancel145 = () => {
    Swal.fire({
      title: "ยกเลิกการเข้ารับบริการ",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ปิด",
    }).then((result) => {
      if (result.isConfirmed) {
        canceldatasss(data14five.AN);
      }
    });
  };


  //five


  //four


  // const [data14four, setData14four] = useState([]);
  // const [data14four2, setData14four2] = useState([]);
  // const [editButton144, setEditButton144] = useState(false);
  // const [icon144, setIcon144] = useState(<EventAvailable />);
  // const [status144, setStatus144] = useState("ว่าง");
  // const [cfer144, setCfer144] = useState(true);
  // const [cancel144, setCancel144] = useState(true);

  // useEffect(() => {
  //   const dateInPast = function (firstDate, secondDate) {
  //     if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
  //       return true;
  //     }
  //     return false;
  //   };
  //   const roletoken = localStorage.getItem("role");
  //   const bbb =
  //     startDate.getDate() +
  //     "-" +
  //     (startDate.getMonth() + 1) +
  //     "-" +
  //     startDate.getFullYear();
  //   const data14one4 = [
  //     {
  //       fname: "ว่าง",
  //       lname: null,
  //       service: "ว่าง",
  //       provider: "ชาย",
  //       date: bbb,
  //       time: "14:45",
  //       prefix: null,
  //     },
  //     {
  //       fname: null,
  //       lname: null,
  //       service: null,
  //       provider: null,
  //       date: null,
  //       time: null,
  //       prefix: null,
  //     },
  //     {
  //       AN: null,
  //       TN: null,
  //       fname: "ปิดบริการ",
  //       lname: "วันหยุดราชการ",
  //       service: "วันหยุดราชการหรืออื่นๆ",
  //       provider: "ชาย",
  //       date: bbb,
  //       time: "14:45",
  //       prefix: null,
  //     },
  //   ];
  //   const aaa = `${URL}/manappoinment/14/`;
  //   const oneURL = aaa + bbb;
  //   const holidaysURL = `${URL}/holidays`;
  //   axios.get(`${holidaysURL}`).then((res) => {
  //     const holidaysearch = startDate.toLocaleDateString("th-TH", {
  //       year: "numeric",
  //       month: "long",
  //       day: "numeric",
  //     });
  //     const holidays = res.data.map((item) => item.date);
  //     const arrayIncludes = holidays.includes(holidaysearch);
  //     if (arrayIncludes !== true) {
  //       axios.get(oneURL).then((res) => {
  //         const resdata144 = res.data.map((item) => {
  //           return item.TN;
  //         });
  //         if (res.data.length === 0) {
  //           if (
  //             (startDate.getDay() === 0 || startDate.getDay() === 6) &&
  //             roletoken === "admin"
  //           ) {
  //             setData14four(data14one4[1]);
  //             setEditButton144(true);
  //             setIcon144(<EventBusy />);
  //             setStatus144("ไม่ว่าง");
  //             setCfer144(true);
  //             setCancel144(true);
  //             return;
  //           }
  //           setData14four(data14one4[0]);
  //           setEditButton144(false);
  //           setIcon144(<EventAvailable />);
  //           setStatus144("ว่างงง");
  //           setCancel144(true);
  //           setCfer144(true);
  //           return;
  //         } else if (res.data.length === 1) {
  //           setData14four(res.data[0]);
  //           setEditButton144(true);
  //           setIcon144(<EventBusy />);
  //           setStatus144("ไม่ว่าง");
  //           if (dateInPast(startDate, new Date())) {
  //             if (resdata144[0] === 1 || resdata144[0] === 2) {
  //               setCfer144(true);
  //               setCancel144(true);
  //               return;
  //             } else if (resdata144[0] > 2 && resdata144[0] < 10) {
  //               setCfer144(true);
  //               setCancel144(false);
  //               return;
  //             } else if (resdata144[0] > 10) {
  //               setCfer144(false);
  //               setCancel144(false);
  //               return;
  //             } else {
  //               setCfer144(false);
  //               setCancel144(false);
  //               return;
  //             }
  //           } else {
  //             setCfer144(true);
  //             setCancel144(false);
  //             return;
  //           }
  //         }
  //       });
  //     } else {
  //       setData14four(data14one4[2]);
  //       setEditButton144(true);
  //       setIcon144(<EventBusy />);
  //       setStatus144("ไม่ว่าง");
  //       setCfer144(true);
  //       setCancel144(true);
  //       return;
  //     }
  //   });
  // }, [startDate, data14four2, URL, time]);

  // //Modalsearch

  // const [selecttn144, setSelecttn144] = useState("");
  // const [selectname144, setSelectname144] = useState("");
  // const [service144, setService144] = useState("");

  // // const handlesave = () => {
  // //   setOpen144(false);
  // // };

  // const [provider144, setProvider144] = useState("ชาย");
  // const handleChangeprovider144 = (event) => {
  //   setProvider144(event.target.value);
  // };

  // const handleChange144 = (event) => {
  //   setService144(event.target.value);
  // };

  // const selectpatient144 = (TN, prefix, fname, lname) => {
  //   setSelecttn144(TN);
  //   setSelectname144(`${prefix}${fname} ${lname}`);
  // };

  // const addmanaappoinment144 = () => {
  //   var data = JSON.stringify({
  //     TN: selecttn144,
  //     date: data14four.date,
  //     time: data14four.time,
  //     service: service144,
  //     provider: provider144,
  //   });

  //   var config = {
  //     method: "post",
  //     url: `${URL}/manapppoinment`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios(config)
  //     .then(function (response) {
  //       Swal.fire({
  //         icon: "success",
  //         title: "นัดหมายเรียบร้อย ",
  //         text: "กรุณาตรวจสอบความถูกต้องด้วยตนเองอีกครั้ง",
  //         showConfirmButton: false,
  //         timer: 1500,
  //       }).then((result) => {
  //         recheck144();
  //         ldataall();
  //         ldatas();
  //         ldatass();
  //         ldatasss();
  //         ldataman();
  //         appdataone();
  //         appdatatwo();
  //         appdatatree();
  //         appdatafour();
  //         appdatafive();
  //         passappblock();
  //         passappconfirm();
  //         setOpen144(false);
  //       });
  //     })
  //     .catch(function (error) {
  //       alert(error);
  //     });
  // };

  // const recheck144 = () => {
  //   const bbb =
  //     startDate.getDate() +
  //     "-" +
  //     (startDate.getMonth() + 1) +
  //     "-" +
  //     startDate.getFullYear();
  //   const aaa = `${URL}/manappoinment/14/`;
  //   const oneURL = aaa + bbb;
  //   axios.get(oneURL).then((res) => {
  //     setData14four2(res.data[0]);
  //   });
  // };

  // const [open144, setOpen144] = useState(false);
  // const handleOpen144 = () => setOpen144(true);
  // const handleClose144 = () => setOpen144(false);

  // const handleOpenin144 = () => {
  //   const bbb =
  //     startDate.getDate() +
  //     "-" +
  //     (startDate.getMonth() + 1) +
  //     "-" +
  //     startDate.getFullYear();
  //   const aaa = `${URL}/manappoinment/14/`;
  //   const oneURL = aaa + bbb;
  //   axios.get(oneURL).then((res) => {
  //     if (res.data.length >= 1) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "เกิดข้อผิดพลาด",
  //         text: "ไม่สามารถทำการนัดหมายได้ เนื่องจากมีคนอื่นนัดหมายช่วงเวลานี้แล้ว",
  //         confirmButtonColor: "#d33",
  //         confirmButtonText: "ปิด",
  //       }).then((result) => {
  //         if (result.isConfirmed) {
  //           setOpen144(false);
  //           recheck144()
  //         }
  //       });
  //       return;
  //     } else if (!service144 || !selecttn144) {
  //       Swal.fire({
  //         icon: "warning",
  //         title: "คำเตือน",
  //         text: "กรุณาระบุหัตถการให้ถูกต้อง",
  //         showConfirmButton: false,
  //         timer: 2500,
  //       });
  //       return;
  //     }
  //     Swal.fire({
  //       title: "ยืนยันการนัดหมาย",
  //       icon: "info",
  //       showCancelButton: true,
  //       confirmButtonColor: "#3085d6",
  //       cancelButtonColor: "#d33",
  //       confirmButtonText: "ยืนยัน",
  //       cancelButtonText: "ยกเลิก",
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         addmanaappoinment144();
  //       }
  //     });
  //   });
  // };

  // // const handleClosein144 = () => setOpenin144(false);

  // //Modalsearch


  // const handleOpencancel144 = () => {
  //   Swal.fire({
  //     title: "ยกเลิกการเข้ารับบริการ",
  //     icon: "info",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "ยืนยัน",
  //     cancelButtonText: "ปิด",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       canceldataman(data14four.AN);
  //     }
  //   });
  // };



  //four

  //14:45


  //หมายเหตุ:

  const [getnote, setGetnote] = useState([]);

  const getnotes = () => {
    const noteblank = [];
    const notedate =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const urlnote = `${URL}/note/${notedate}`;
    axios.get(urlnote).then((res) => {
      if (res.data.length === 0) {
        setGetnote(noteblank)
        return;
      }
      else {
        setGetnote(res.data)
        return;
      }
    });
  }

  useEffect(() => {
    const noteblankk = [];
    const notedatee =
      startDate.getDate() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getFullYear();
    const urlnote = `${URL}/note/${notedatee}`;
    axios.get(urlnote).then((res) => {
      if (res.data.length === 0) {
        setGetnote(noteblankk)
        return;
      }
      else {
        setGetnote(res.data)
        return;
      }
    });
  }, [startDate, URL]);



  const [note1, setNote1] = useState("");
  const [openaddnote, setAddnote] = useState(false);
  const handleOpenaddnote = () => setAddnote(true);
  const handleCloseaddnote = () => setAddnote(false);

  const submitnote = (event) => {
    event.preventDefault();

    const datenote = startDate.getDate() + "-" + (startDate.getMonth() + 1) + "-" + startDate.getFullYear();

    axios
      .post(`${URL}/note`, {
        note: note1,
        date: datenote,
      })
      .then(function (response) {
        if (response.data["status"] === "OK") {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "เพิ่มรายการเรียบร้อย",
            showConfirmButton: false,
            timer: 1500,
          }).then((result) => {
            setNote1("")
            getnotes()
            handleCloseaddnote();
            return;
          });
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "ผิดพลาด",
            text: "ไม่สามารถเพิ่มรายการได้",
            showConfirmButton: false,
            timer: 2500,
          }).then((result) => {
            setNote1("")
            getnotes()
            handleCloseaddnote();
            return;
          });
        }
      })
      .catch(function (error) {
        alert(error);
      });

  };

  const senddeletenote = (NN) => {
    Swal.fire({
      title: 'ยืนยันการลบข้อมูล',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.isConfirmed) {
        deletenote(NN)
      }
    })
  }

  const deletenote = (NN) => {
    var data = JSON.stringify({
      NN: NN,
    });

    var config = {
      method: "delete",
      url: `${URL}/note`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        Swal.fire({
          icon: "success",
          title: "เสร็จสิ้น",
          text: "ทำการลบข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          getnotes()
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };


  const [editnote, setEditnote] = useState(null);
  const [editnoteNN, setEditnoteNN] = useState(null);
  const [openeditnote, setOpeneditnote] = useState(false);
  const handleCloseeditnote = () => setOpeneditnote(false);
  const handleOpeneditnote = (NN, note) => {
    setEditnoteNN(NN)
    setEditnote(note)
    setOpeneditnote(true)
    return
  };

  const submiteditnote = (event) => {
    event.preventDefault()
    axios
      .put(`${URL}/note/${editnoteNN}`, {
        note: editnote,
      })
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        if (response.data['status'] === 'OK') {
          Swal.fire({
            icon: 'success',
            title: 'เสร็จสิ้น',
            text: 'แก้ไขหมายเหตุเรียบร้อยแล้ว',
            showConfirmButton: false,
            timer: 1500
          }).then((result) => {
            getnotes()
            handleCloseeditnote()
          })
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }



  //หมายเหตุ:



  //นัดจำนวนการนัดหมาย
  const [dataall, setDataall] = useState([0]);
  const [adata, setAdata] = useState([0]);
  const [bdata, setBdata] = useState([0]);
  const [cdata, setCdata] = useState([0]);
  const ldataall = () => {
    const usersURL = `${URL}/appoinment`;
    axios.get(`${usersURL}`).then((res) => {
      setDataall(
        res.data.filter((e) => {
          return e.TN === 1 || e.TN === 2;
        })
      );
      setAdata(
        res.data.filter((e) => {
          return e.TN > 9;
        })
      );
      setBdata(
        res.data.filter((e) => {
          return e.TN === 2;
        })
      );
      setCdata(
        res.data.filter((e) => {
          return e.TN === 1;
        })
      );
    });
  };

  const [datas, setDatas] = useState([0]);
  const [adatas, setAdatas] = useState([0]);
  const [bdatas, setBdatas] = useState([0]);
  const [cdatas, setCdatas] = useState([0]);
  const ldatas = () => {
    const usersURL = `${URL}/appoinments`;
    axios.get(`${usersURL}`).then((res) => {
      setDatas(
        res.data.filter((e) => {
          return e.TN === 1 || e.TN === 2;
        })
      );
      setAdatas(
        res.data.filter((e) => {
          return e.TN > 9;
        })
      );
      setBdatas(
        res.data.filter((e) => {
          return e.TN === 2;
        })
      );
      setCdatas(
        res.data.filter((e) => {
          return e.TN === 1;
        })
      );
    });
  };

  const [datass, setDatass] = useState([0]);
  const [adatass, setAdatass] = useState([0]);
  const [bdatass, setBdatass] = useState([0]);
  const [cdatass, setCdatass] = useState([0]);
  const ldatass = () => {
    const usersURL = `${URL}/appoinmentss`;
    axios.get(`${usersURL}`).then((res) => {
      setDatass(
        res.data.filter((e) => {
          return e.TN === 1 || e.TN === 2;
        })
      );
      setAdatass(
        res.data.filter((e) => {
          return e.TN > 9;
        })
      );
      setBdatass(
        res.data.filter((e) => {
          return e.TN === 2;
        })
      );
      setCdatass(
        res.data.filter((e) => {
          return e.TN === 1;
        })
      );
    });
  };

  const [datasss, setDatasss] = useState([0]);
  const [adatasss, setAdatasss] = useState([0]);
  const [bdatasss, setBdatasss] = useState([0]);
  const [cdatasss, setCdatasss] = useState([0]);
  const ldatasss = () => {
    const usersURL = `${URL}/appoinmentsss`;
    axios.get(`${usersURL}`).then((res) => {
      setDatasss(
        res.data.filter((e) => {
          return e.TN === 1 || e.TN === 2;
        })
      );
      setAdatasss(
        res.data.filter((e) => {
          return e.TN > 9;
        })
      );
      setBdatasss(
        res.data.filter((e) => {
          return e.TN === 2;
        })
      );
      setCdatasss(
        res.data.filter((e) => {
          return e.TN === 1;
        })
      );
    });
  };

  const [dataman, setDataman] = useState([0]);
  const [adataman, setAdataman] = useState([0]);
  const [bdataman, setBdataman] = useState([0]);
  const [cdataman, setCdataman] = useState([0]);
  const ldataman = () => {
    const usersURL = `${URL}/manappoinment`;
    axios.get(`${usersURL}`).then((res) => {
      setDataman(
        res.data.filter((e) => {
          return e.TN === 1 || e.TN === 2;
        })
      );
      setAdataman(
        res.data.filter((e) => {
          return e.TN > 9;
        })
      );
      setBdataman(
        res.data.filter((e) => {
          return e.TN === 2;
        })
      );
      setCdataman(
        res.data.filter((e) => {
          return e.TN === 1;
        })
      );
    });
  };



  const alldata = [...dataall, ...datas, ...datass, ...datasss, ...dataman];
  const alldatal = alldata.length;
  const alldatap = 100;

  const Aalldata = [...adata, ...adatas, ...adatass, ...adatasss, ...adataman];
  const Aalldatal = Aalldata.length;

  const Balldata = [...bdata, ...bdatas, ...bdatass, ...bdatasss, ...bdataman];
  const Balldatal = Balldata.length;
  const Balldatap = (Balldatal * 100) / alldatal;

  const Calldata = [...cdata, ...cdatas, ...cdatass, ...cdatasss, ...cdataman];
  const Calldatal = Calldata.length;
  const Calldatap = (Calldatal * 100) / alldatal;

  //searchback
  const [appdata, setAppdata] = useState([]);
  const appdataone = () => {
    const usersURL = `${URL}/appoinment`;
    axios.get(`${usersURL}`).then((res) => {
      setAppdata(
        res.data.filter((e) => {
          return e.TN > 9;
        })
      );
    });
  };

  const [appdatas, setAppdatas] = useState([]);
  const appdatatwo = () => {
    const usersURL = `${URL}/appoinments`;
    axios.get(`${usersURL}`).then((res) => {
      setAppdatas(
        res.data.filter((e) => {
          return e.TN > 9;
        })
      );
    });
  };

  const [appdatass, setAppdatass] = useState([]);
  const appdatatree = () => {
    const usersURL = `${URL}/appoinmentss`;
    axios.get(`${usersURL}`).then((res) => {
      setAppdatass(
        res.data.filter((e) => {
          return e.TN > 9;
        })
      );
    });
  };

  const [appdatasss, setAppdatasss] = useState([]);
  const appdatafive = () => {
    const usersURL = `${URL}/appoinmentsss`;
    axios.get(`${usersURL}`).then((res) => {
      setAppdatasss(
        res.data.filter((e) => {
          return e.TN > 9;
        })
      );
    });
  };

  const [appdataman, setAppdataman] = useState([]);
  const appdatafour = () => {
    const usersURL = `${URL}/manappoinment`;
    axios.get(`${usersURL}`).then((res) => {
      setAppdataman(
        res.data.filter((e) => {
          return e.TN > 9;
        })
      );
    });
  };

  const [passconfirmapp, setPassconfirmapp] = useState([]);
  const passappconfirm = () => {
    const usersURL = `${URL}/passconfirmapp`;
    axios.get(`${usersURL}`).then((res) => {
      setPassconfirmapp(
        res.data.filter((e) => {
          return e.TN > 9;
        })
      );
    });
  };

  const [passblockapp, setPassblockapp] = useState([]);
  const passappblock = () => {
    const usersURL = `${URL}/passblockapp`;
    axios.get(`${usersURL}`).then((res) => {
      setPassblockapp(
        res.data.filter((e) => {
          return e.TN > 9;
        })
      );
    });
  };

  const appalldata = [
    ...appdata,
    ...appdatas,
    ...appdatass,
    ...appdatasss,
    ...appdataman,
    ...passconfirmapp,
    ...passblockapp,
  ];

  const [appsearch, setAppsearch] = useState(null);
  const apptesttt = (e) => {
    if (e.target.value === "") {
      return setAppsearch(null);
    } else {
      return setAppsearch(e.target.value);
    }
  };

  return (
    <div>
      <CssBaseline />
      <Container>
        <Logo />
        <Box>
          <Paper style={{ marginTop: "30px", marginBottom: '50px', padding: '30px', border: 'solid 1.5px #e79129' }}>
            <div style={{ textAlign: "center" }}>
              <h2 style={{ margin: "10px 10px 10px 10px" }}>
                <span style={{ marginRight: "50px" }}></span>
                <DatePicker
                  onChange={(Date) => setStartDate(Date)}
                  value={startDate}
                  format="dd-MM-y"
                  locale="th-TH"
                  minDate={new Date()}
                />
                <span style={{ marginLeft: "10px", fontSize: "small" }}>
                  {dayname}
                </span>
              </h2>
            </div>
            <div className="testtest">
              <table className="ondate">
                <tbody>
                  <tr className="head">
                    <th className="headtime">เวลา</th>
                    <th className="headname">ชื่อ-สกุล</th>
                    <th className="headservice">หัตถการ</th>
                    <th className="headprovider">ผู้ให้บริการ</th>
                    <th className="headstatus">
                      สถานะ
                    </th>
                  </tr>
                  <tr className="bodynine">
                    <td className="bodytime">09:00 น.</td>
                    <td className="bodyname">
                      {data9one.prefix}
                      {data9one.fname} {data9one.lname}
                    </td>
                    <td className="bodyservice">{data9one.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        className="btnstatus"
                        startIcon={icon91}
                        disabled={editButton91}
                        onClick={handleOpen91}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status91}
                      </Button>
                      <Modal
                        open={open91}
                        onClose={handleClose91}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={styleelogin}>
                          <ThemeProvider theme={theme}>
                            <Container component="main" maxWidth="xs">
                              <CssBaseline />
                              <Box
                                sx={{
                                  marginTop: 2,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                }}
                              >
                                <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                                  <LockOutlinedIcon />
                                </Avatar>
                                <Typography component="h1" variant="h5">
                                  กรุณาเข้าสู่ระบบ
                                </Typography>
                                <Box component="form" onSubmit={handleCheckpin91} noValidate sx={{ mt: 1 }}>
                                  <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    label="เบอร์โทรศัพท์"
                                    name="tel"
                                    type="number"
                                    autoComplete="tel"
                                    autoFocus
                                  />
                                  <TextField
                                    margin="normal"
                                    style={{ marginBottom: '20px' }}
                                    required
                                    fullWidth
                                    name="pin"
                                    label="กรุณากรอกรหัส 6 หลัก"
                                    type="password"
                                    autoComplete="current-password"
                                  />
                                  <Grid>
                                    <Grid container spacing={2}>
                                      <Grid item xs={8}>
                                        <Button
                                          type="submit"
                                          fullWidth
                                          variant="contained"
                                          color="success"
                                        >
                                          เข้าสู่ระบบ
                                        </Button>
                                      </Grid>
                                      <Grid item xs={4}>
                                        <Button
                                          color="warning"
                                          fullWidth
                                          variant="contained"
                                          onClick={handleClose91}
                                        >
                                          ยกเลิก
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Box>
                              </Box>
                              <hr style={{ marginTop: '20px' }} />
                              <h5 style={{ marginTop: '20px', marginBottom: '20px', textAlign: 'center' }} >
                                กรณีลืมรหัส 6 หลัก ให้ติดต่อเจ้าหน้าที่เพื่อรีซ็ตรหัสผ่าน
                              </h5>
                            </Container>
                          </ThemeProvider>
                        </Box>
                      </Modal>
                      <Modal
                        open={open911}
                        onClose={handleClose911}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h5" gutterBottom component="div" style={{ textAlign: 'center'}}>
                                  รายละเอียดการนัดหมาย
                                </Typography>
                                <Typography variant="h6" gutterBottom component="div" style={{ textAlign: 'center', marginBottom: '20px' }}>
                                  {selectname91}
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data9one.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data9one.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service91}
                                          onChange={handleChange91}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดเท้าเพื่อสุขภาพ">
                                            นวดเท้าเพื่อสุขภาพ
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        color="success"
                                        type="submit"
                                        variant="contained"
                                        fullWidth
                                        onClick={handleOpenin91}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        color='warning'
                                        fullWidth
                                        variant="contained" 
                                        onClick={handleClose911}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel91}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpencancel911}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                      <Modal
                        open={cancel911}
                        onClose={handleClosecancel911}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <ThemeProvider theme={theme}>
                            <Container component="main" maxWidth="xs">
                              <CssBaseline />
                              <Box
                                sx={{
                                  marginTop: 2,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                }}
                              >
                                <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                                  <LockOutlinedIcon />
                                </Avatar>
                                <Typography component="h1" variant="h5">
                                  คุณ{data9one.fname} {data9one.lname}
                                </Typography>
                                <Box component="form" onSubmit={handleCancelpin91}
                                  noValidate sx={{ mt: 1 }}>
                                  <TextField
                                    margin="normal"
                                    style={{ marginBottom: '20px' }}
                                    required
                                    fullWidth
                                    name="pin"
                                    label="กรุณากรอกรหัส 6 หลัก"
                                    type="password"
                                    autoComplete="current-password"
                                  />
                                  <Grid>
                                    <Grid container spacing={2}>
                                      <Grid item xs={8}>
                                        <Button
                                          type="submit"
                                          fullWidth
                                          variant="contained"
                                        >
                                          ยืนยัน
                                        </Button>
                                      </Grid>
                                      <Grid item xs={4}>
                                        <Button
                                          color="error"
                                          fullWidth
                                          variant="contained"
                                          onClick={handleClosecancel911}
                                        >
                                          ยกเลิก
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Box>
                              </Box>
                              <hr style={{ marginTop: '20px' }} />
                              <h5 style={{ marginTop: '20px', marginBottom: '20px', textAlign: 'center' }} >
                                กรณีลืมรหัส 6 หลัก ให้ติดต่อเจ้าหน้าที่เพื่อรีซ็ตรหัสผ่าน
                              </h5>
                            </Container>
                          </ThemeProvider>
                        </Box>
                      </Modal>
                    </td>
                  </tr>
                  <tr className="bodynine">
                    <td className="bodytime">09:00 น.</td>
                    <td className="bodyname">
                      {data9two.prefix}
                      {data9two.fname} {data9two.lname}
                    </td>
                    <td className="bodyservice">{data9two.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        startIcon={icon92}
                        disabled={editButton92}
                        onClick={handleOpen92}
                        style={{ margin: "0 0 0 4px" }}
                        className="btnstatus"
                      >
                        {status92}
                      </Button>
                      <Modal
                        open={open92}
                        onClose={handleClose92}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={styleelogin}>
                          <ThemeProvider theme={theme}>
                            <Container component="main" maxWidth="xs">
                              <CssBaseline />
                              <Box
                                sx={{
                                  marginTop: 2,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                }}
                              >
                                <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                                  <LockOutlinedIcon />
                                </Avatar>
                                <Typography component="h1" variant="h5">
                                  กรุณาเข้าสู่ระบบ
                                </Typography>
                                <Box component="form" onSubmit={handleCheckpin92} noValidate sx={{ mt: 1 }}>
                                  <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    label="เบอร์โทรศัพท์"
                                    name="tel"
                                    type="number"
                                    autoComplete="tel"
                                    autoFocus
                                  />
                                  <TextField
                                    margin="normal"
                                    style={{ marginBottom: '20px' }}
                                    required
                                    fullWidth
                                    name="pin"
                                    label="กรุณากรอกรหัส 6 หลัก"
                                    type="password"
                                    autoComplete="current-password"
                                  />
                                  <Grid>
                                    <Grid container spacing={2}>
                                      <Grid item xs={8}>
                                        <Button
                                          type="submit"
                                          fullWidth
                                          variant="contained"
                                          color="success"
                                        >
                                          เข้าสู่ระบบ
                                        </Button>
                                      </Grid>
                                      <Grid item xs={4}>
                                        <Button
                                          color="warning"
                                          fullWidth
                                          variant="contained"
                                          onClick={handleClose92}
                                        >
                                          ยกเลิก
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Box>
                              </Box>
                              <hr style={{ marginTop: '20px' }} />
                              <h5 style={{ marginTop: '20px', marginBottom: '20px', textAlign: 'center' }} >
                                กรณีลืมรหัส 6 หลัก ให้ติดต่อเจ้าหน้าที่เพื่อรีซ็ตรหัสผ่าน
                              </h5>
                            </Container>
                          </ThemeProvider>
                        </Box>
                      </Modal>
                      <Modal
                        open={open912}
                        onClose={handleClose912}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}> 
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h5" gutterBottom component="div" style={{ textAlign: 'center'}}>
                                  รายละเอียดการนัดหมาย
                                </Typography>
                                <Typography variant="h6" gutterBottom component="div" style={{ textAlign: 'center', marginBottom: '20px' }}>
                                  {selectname92}
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data9two.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data9two.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service92}
                                          onChange={handleChange92}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดเท้าเพื่อสุขภาพ">
                                            นวดเท้าเพื่อสุขภาพ
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        color="success"
                                        type="submit"
                                        variant="contained"
                                        fullWidth
                                        onClick={handleOpenin92}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        color='warning'
                                        fullWidth
                                        variant="contained" 
                                        onClick={handleClose912}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel92}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpencancel912}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                      <Modal
                        open={cancel912}
                        onClose={handleClosecancel912}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <ThemeProvider theme={theme}>
                            <Container component="main" maxWidth="xs">
                              <CssBaseline />
                              <Box
                                sx={{
                                  marginTop: 2,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                }}
                              >
                                <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                                  <LockOutlinedIcon />
                                </Avatar>
                                <Typography component="h1" variant="h5">
                                  คุณ{data9two.fname} {data9two.lname}
                                </Typography>
                                <Box component="form" onSubmit={handleCancelpin92}
                                  noValidate sx={{ mt: 1 }}>
                                  <TextField
                                    margin="normal"
                                    style={{ marginBottom: '20px' }}
                                    required
                                    fullWidth
                                    name="pin"
                                    label="กรุณากรอกรหัส 6 หลัก"
                                    type="password"
                                    autoComplete="current-password"
                                  />
                                  <Grid>
                                    <Grid container spacing={2}>
                                      <Grid item xs={8}>
                                        <Button
                                          color="success"
                                          fullWidth
                                          variant="contained"
                                        >
                                          ยืนยัน
                                        </Button>
                                      </Grid>
                                      <Grid item xs={4}>
                                        <Button
                                          color="warning"
                                          fullWidth
                                          variant="contained"
                                          onClick={handleClosecancel912}
                                        >
                                          ยกเลิก
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Box>
                              </Box>
                              <hr style={{ marginTop: '20px' }} />
                              <h5 style={{ marginTop: '20px', marginBottom: '20px', textAlign: 'center' }} >
                                กรณีลืมรหัส 6 หลัก ให้ติดต่อเจ้าหน้าที่เพื่อรีซ็ตรหัสผ่าน
                              </h5>
                            </Container>
                          </ThemeProvider>
                        </Box>
                      </Modal>
                    </td>
                  </tr>
                  <tr className="bodynine">
                    <td className="bodytime">09:00 น.</td>
                    <td className="bodyname">
                      {data9tree.prefix}
                      {data9tree.fname} {data9tree.lname}
                    </td>
                    <td className="bodyservice">{data9tree.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        color="success"
                        className="btnstatus"
                        size="small"
                        startIcon={icon93}
                        disabled={editButton93}
                        onClick={handleOpen}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status93}
                      </Button>
                      <Modal
                        open={open93}
                        onClose={handleClose93}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient93(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn93}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname93}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data9tree.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data9tree.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service93}
                                          onChange={handleChange93}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin93}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose93}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel93}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr>
                  <tr className="bodynine">
                    <td className="bodytime">09:00 น.</td>
                    <td className="bodyname">
                      {data9five.prefix}
                      {data9five.fname} {data9five.lname}
                    </td>
                    <td className="bodyservice">{data9five.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        color="success"
                        className="btnstatus"
                        size="small"
                        startIcon={icon95}
                        disabled={editButton95}
                        onClick={handleOpen}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status95}
                      </Button>
                      <Modal
                        open={open95}
                        onClose={handleClose95}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient95(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn95}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname95}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data9five.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data9five.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service95}
                                          onChange={handleChange95}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin95}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose95}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel95}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr>
                  {/* <tr className="bodynine">
                    <td className="bodytime">09:00 น.</td>
                    <td className="bodyname">
                      {data9four.prefix}
                      {data9four.fname} {data9four.lname}
                    </td>
                    <td className="bodyservice">{data9four.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        className="btnstatus"
                        color="success"
                        size="small"
                        startIcon={icon94}
                        disabled={editButton94}
                        onClick={handleOpen94}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status94}
                      </Button>
                      <Modal
                        open={open94}
                        onClose={handleClose94}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient94(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn94}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname94}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data9four.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data9four.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                    <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                        เจ้าหน้าที่
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={provider94}
                                          onChange={handleChangeprovider94}
                                          label="เจ้าหน้าที่"
                                        >
                                          <MenuItem value="ชาย">ชาย</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service94}
                                          onChange={handleChange94}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin94}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose94}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel94}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr> */}
                  <tr className="bodyten">
                    <td className="bodytime">10:15 น.</td>
                    <td className="bodyname">
                      {data10one.prefix}
                      {data10one.fname} {data10one.lname}
                    </td>
                    <td className="bodyservice">{data10one.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        className="btnstatus"
                        color="success"
                        size="small"
                        startIcon={icon101}
                        disabled={editButton101}
                        onClick={handleOpen}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status101}
                      </Button>
                      <Modal
                        open={open101}
                        onClose={handleClose101}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient101(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn101}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname101}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data10one.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data10one.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service101}
                                          onChange={handleChange101}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin101}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose101}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel101}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr>
                  <tr className="bodyten">
                    <td className="bodytime">10:15 น.</td>
                    <td className="bodyname">
                      {data10two.prefix}
                      {data10two.fname} {data10two.lname}
                    </td>
                    <td className="bodyservice">{data10two.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        className="btnstatus"
                        color="success"
                        size="small"
                        startIcon={icon102}
                        onClick={handleOpen}
                        disabled={editButton102}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status102}
                      </Button>
                      <Modal
                        open={open102}
                        onClose={handleClose102}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient102(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn102}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname102}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data10two.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data10two.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service102}
                                          onChange={handleChange102}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin102}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose102}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel102}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr>
                  <tr className="bodyten">
                    <td className="bodytime">10:15 น.</td>
                    <td className="bodyname">
                      {data10tree.prefix}
                      {data10tree.fname} {data10tree.lname}
                    </td>
                    <td className="bodyservice">{data10tree.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        className="btnstatus"
                        color="success"
                        size="small"
                        startIcon={icon103}
                        disabled={editButton103}
                        onClick={handleOpen}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status103}
                      </Button>
                      <Modal
                        open={open103}
                        onClose={handleClose103}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient103(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn103}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname103}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data10tree.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data10tree.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service103}
                                          onChange={handleChange103}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin103}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose103}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel103}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr>
                  <tr className="bodyten">
                    <td className="bodytime">10:15 น.</td>
                    <td className="bodyname">
                      {data10five.prefix}
                      {data10five.fname} {data10five.lname}
                    </td>
                    <td className="bodyservice">{data10five.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        className="btnstatus"
                        color="success"
                        size="small"
                        startIcon={icon105}
                        disabled={editButton105}
                        onClick={handleOpen}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status105}
                      </Button>
                      <Modal
                        open={open105}
                        onClose={handleClose105}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient105(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn105}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname105}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data10five.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data10five.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service105}
                                          onChange={handleChange105}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin105}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose105}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel105}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr>
                  {/* <tr className="bodyten">
                    <td className="bodytime">10:15 น.</td>
                    <td className="bodyname">
                      {data10four.prefix}
                      {data10four.fname} {data10four.lname}
                    </td>
                    <td className="bodyservice">{data10four.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        className="btnstatus"
                        color="success"
                        size="small"
                        startIcon={icon104}
                        onClick={handleOpen104}
                        disabled={editButton104}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status104}
                      </Button>
                      <Modal
                        open={open104}
                        onClose={handleClose104}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient104(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn104}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname104}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data10four.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data10four.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                    <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                        เจ้าหน้าที่
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={provider104}
                                          onChange={handleChangeprovider104}
                                          label="เจ้าหน้าที่"
                                        >
                                          <MenuItem value="ชาย">ชาย</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service104}
                                          onChange={handleChange104}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin104}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose104}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel104}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpencancel104}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr> */}
                  <tr className="body13">
                    <td className="bodytime">13:30 น.</td>
                    <td className="bodyname">
                      {data13one.prefix}
                      {data13one.fname} {data13one.lname}
                    </td>
                    <td className="bodyservice">{data13one.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        color="success"
                        className="btnstatus"
                        size="small"
                        startIcon={icon131}
                        onClick={handleOpen}
                        disabled={editButton131}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status131}
                      </Button>
                      <Modal
                        open={open131}
                        onClose={handleClose131}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient131(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn131}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname131}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data13one.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data13one.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service131}
                                          onChange={handleChange131}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin131}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose91}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel131}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr>
                  <tr className="body13">
                    <td className="bodytime">13:30 น.</td>
                    <td className="bodyname">
                      {data13two.prefix}
                      {data13two.fname} {data13two.lname}
                    </td>
                    <td className="bodyservice">{data13two.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        color="success"
                        className="btnstatus"
                        size="small"
                        startIcon={icon132}
                        onClick={handleOpen}
                        disabled={editButton132}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status132}
                      </Button>
                      <Modal
                        open={open132}
                        onClose={handleClose132}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient132(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn132}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname132}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data13two.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data13two.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service132}
                                          onChange={handleChange132}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin132}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose132}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel132}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr>
                  <tr className="body13">
                    <td className="bodytime">13:30 น.</td>
                    <td className="bodyname">
                      {data13tree.prefix}
                      {data13tree.fname} {data13tree.lname}
                    </td>
                    <td className="bodyservice">{data13tree.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        color="success"
                        className="btnstatus"
                        size="small"
                        startIcon={icon133}
                        onClick={handleOpen}
                        disabled={editButton133}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status133}
                      </Button>
                      <Modal
                        open={open133}
                        onClose={handleClose133}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient133(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn133}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname133}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data13tree.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data13tree.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service133}
                                          onChange={handleChange133}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin133}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose133}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel133}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr>
                  <tr className="body13">
                    <td className="bodytime">13:30 น.</td>
                    <td className="bodyname">
                      {data13five.prefix}
                      {data13five.fname} {data13five.lname}
                    </td>
                    <td className="bodyservice">{data13five.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        color="success"
                        className="btnstatus"
                        size="small"
                        startIcon={icon135}
                        onClick={handleOpen}
                        disabled={editButton135}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status135}
                      </Button>
                      <Modal
                        open={open135}
                        onClose={handleClose135}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient135(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn135}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname135}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data13five.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data13five.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service135}
                                          onChange={handleChange135}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin135}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose135}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel135}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr>
                  {/* <tr className="body13">
                    <td className="bodytime">13:30 น.</td>
                    <td className="bodyname">
                      {data13four.prefix}
                      {data13four.fname} {data13four.lname}
                    </td>
                    <td className="bodyservice">{data13four.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        className="btnstatus"
                        startIcon={icon134}
                        disabled={editButton134}
                        onClick={handleOpen134}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status134}
                      </Button>
                      <Modal
                        open={open134}
                        onClose={handleClose134}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient134(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn134}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname134}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data13four.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data13four.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                        เจ้าหน้าที่
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={provider134}
                                          onChange={handleChangeprovider134}
                                          label="เจ้าหน้าที่"
                                        >
                                          <MenuItem value="ชาย">ชาย</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service134}
                                          onChange={handleChange134}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin134}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose134}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel134}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpencancel134}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr> */}
                  <tr className="body14">
                    <td className="bodytime">14:45 น.</td>
                    <td className="bodyname">
                      {data14one.prefix}
                      {data14one.fname} {data14one.lname}
                    </td>
                    <td className="bodyservice">{data14one.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        color="success"
                        className="btnstatus"
                        size="small"
                        onClick={handleOpen}
                        startIcon={icon141}
                        disabled={editButton141}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status141}
                      </Button>
                      <Modal
                        open={open141}
                        onClose={handleClose141}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient141(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn141}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname141}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data14one.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data14one.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service141}
                                          onChange={handleChange141}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin141}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose141}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel141}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr>
                  <tr className="body14">
                    <td className="bodytime">14:45 น.</td>
                    <td className="bodyname">
                      {data14two.prefix}
                      {data14two.fname} {data14two.lname}
                    </td>
                    <td className="bodyservice">{data14two.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        className="btnstatus"
                        color="success"
                        size="small"
                        onClick={handleOpen}
                        startIcon={icon142}
                        disabled={editButton142}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status142}
                      </Button>
                      <Modal
                        open={open142}
                        onClose={handleClose142}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient142(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn142}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname142}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data14two.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data14two.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service142}
                                          onChange={handleChange142}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin142}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose142}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel142}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr>
                  <tr className="body14">
                    <td className="bodytime">14:45 น.</td>
                    <td className="bodyname">
                      {data14tree.prefix}
                      {data14tree.fname} {data14tree.lname}
                    </td>
                    <td className="bodyservice">{data14tree.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        className="btnstatus"
                        color="success"
                        size="small"
                        startIcon={icon143}
                        disabled={editButton143}
                        onClick={handleOpen}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status143}
                      </Button>
                      <Modal
                        open={open143}
                        onClose={handleClose143}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient143(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn143}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname143}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data14tree.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data14tree.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service143}
                                          onChange={handleChange143}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin143}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose143}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel143}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr>
                  <tr className="body14">
                    <td className="bodytime">14:45 น.</td>
                    <td className="bodyname">
                      {data14five.prefix}
                      {data14five.fname} {data14five.lname}
                    </td>
                    <td className="bodyservice">{data14five.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        className="btnstatus"
                        color="success"
                        size="small"
                        startIcon={icon145}
                        disabled={editButton145}
                        onClick={handleOpen}
                        style={{ margin: "0 0 0 4px" }}
                      >
                        {status145}
                      </Button>
                      <Modal
                        open={open145}
                        onClose={handleClose145}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <TextField
                                  fullWidth
                                  id="fullWidth"
                                  label="ค้นหา..."
                                  variant="outlined"
                                  onChange={testtt}
                                  size="small"
                                />
                              </Box>
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient145(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 2 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn145}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname145}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data14five.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        value={`${data14five.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="provider"
                                        label="เจ้าหน้าที่"
                                        value="หญิง"
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service145}
                                          onChange={handleChange145}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin145}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose145}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel145}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr>
                  {/* <tr className="body14">
                    <td className="bodytime">14:45 น.</td>
                    <td className="bodyname">
                      {data14four.prefix}
                      {data14four.fname} {data14four.lname}
                    </td>
                    <td className="bodyservice">{data14four.service}</td>
                    <td className="bodyprovider">หญิง</td>
                    <td className="bodystatus">
                      <Button
                        variant="contained"
                        className="btnstatus"
                        color="success"
                        size="small"
                        startIcon={icon144}
                        disabled={editButton144}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpen144}
                      >
                        {status144}
                      </Button>
                      <Modal
                        open={open144}
                        onClose={handleClose144}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={stylee}>
                          <Paper>
                            <Box display="flex">
                              <TextField
                                fullWidth
                                id="fullWidth"
                                label="ค้นหา..."
                                onChange={testtt}
                                size="small"
                                variant="outlined"
                              />
                            </Box>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "4px",
                              }}
                            >
                              <TableContainer
                                sx={{ height: "160px", maxWidth: "320px" }}
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          maxHeight: "30px",
                                          padding: "5px 0 5px 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        TN
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        ชื่อสกุล
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxHeight: "30px",
                                          padding: "0 0 0 0",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        สิทธิ์
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          maxWidth: "60px",
                                          padding: "5px 5px 5px 5px",
                                          backgroundColor: "#1bb3b3",
                                        }}
                                      >
                                        เลือก
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data
                                      .filter((e) => {
                                        return (
                                          e.fname.includes(search) ||
                                          e.lname.includes(search) ||
                                          e.TN.toString().includes(search) ||
                                          e.tel.includes(search)
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <TableRow key={item.TN}>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 0 5px 0",
                                              }}
                                            >
                                              {item.TN}
                                            </TableCell>
                                            <TableCell
                                              style={{ padding: "0 0 0 5px" }}
                                            >
                                              {item.fname} {item.lname}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxHeight: "30px",
                                                padding: "0 0 0 0",
                                              }}
                                            >
                                              {item.role}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{
                                                maxWidth: "60px",
                                                padding: "5px 5px 5px 5px",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                  margin: "0 0 0 8px",
                                                  display: "contents",
                                                }}
                                                onClick={() => {
                                                  return selectpatient144(
                                                    item.TN,
                                                    item.prefix,
                                                    item.fname,
                                                    item.lname
                                                  );
                                                }}
                                              >
                                                <Send
                                                  color="secondary"
                                                  size="small"
                                                />
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Paper>
                          <Paper style={{ marginTop: 10 }}>
                            <Grid item xs={4} sm={4}>
                              <CssBaseline />
                              <Container maxWidth="sm" sx={{ p: 1 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                  ลงนัดคนไข้
                                </Typography>
                                <Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="TN"
                                        label="TN"
                                        size="small"
                                        variant="standard"
                                        placeholder="กรุณากรอก TN"
                                        value={`${selecttn144}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="fullname"
                                        label="ชื่อสกุล"
                                        size="small"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${selectname144}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <TextField
                                        id="date"
                                        label="วันที่"
                                        size="small"
                                        variant="standard"
                                        placeholder="กรุณากรอกชื่อ-สกุล"
                                        value={`${data14four.date}`}
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <TextField
                                        id="time"
                                        label="เวลา"
                                        size="small"
                                        value={`${data14four.time}`}
                                        variant="standard"
                                        required
                                      />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                      <FormControl variant="standard" fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">
                                        เจ้าหน้าที่
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={provider144}
                                          onChange={handleChangeprovider144}
                                          label="เจ้าหน้าที่"
                                        >
                                          <MenuItem value="ชาย">ชาย</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                      <FormControl
                                        variant="standard"
                                        size="small"
                                        fullWidth
                                      >
                                        <InputLabel id="demo-simple-select-standard-label">
                                          หัตถการ
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          value={service144}
                                          onChange={handleChange144}
                                          label="service"
                                        >
                                          <MenuItem value="นวด">นวด</MenuItem>
                                          <MenuItem value="ประคบ">ประคบ</MenuItem>
                                          <MenuItem value="อบสมุนไพร">
                                            อบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวดและประคบ">
                                            นวดและประคบ
                                          </MenuItem>
                                          <MenuItem value="นวดและอบสมุนไพร">
                                            นวดและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="ประคบและอบสมุนไพร">
                                            ประคบและอบสมุนไพร
                                          </MenuItem>
                                          <MenuItem value="นวด ประคบและอบสมุนไพร">
                                            นวด ประคบและอบสมุนไพร
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenin144}
                                      >
                                        นัดหมาย
                                      </Button>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        onClick={handleClose144}
                                      >
                                        ยกเลิก
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Container>
                            </Grid>
                          </Paper>
                        </Box>
                      </Modal>
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        disabled={cancel144}
                        startIcon={<CancelOutlined />}
                        style={{ margin: "0 0 0 4px" }}
                        onClick={handleOpencancel144}
                        className="btnstatus"
                      >
                        ยกเลิก
                      </Button>
                    </td>
                  </tr> */}
                </tbody>
              </table>
            </div>
          </Paper>
          <Article />
        </Box>
      </Container>

    </div>
  );
};
export default Appoinment;
